var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _g2, _path10, _g3, _path11, _path12, _g4, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _g5, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _g6, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 388,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.017 356.914H390.76v-206.57H48.017v206.57Z",
    fill: "#C6B85D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.433 236.493c-8.864 0-16.044-8.045-16.044-17.97 0 8.38-5.126 15.424-12.051 17.414v-47.848c0-.647-.526-1.17-1.173-1.17h-4.099v-2.632c0-.647-.523-1.174-1.17-1.174H241.25c-.647 0-1.17.527-1.17 1.174v47.309c-3.103-3.276-5.036-7.92-5.036-13.073 0 5.51-2.215 10.441-5.701 13.739v-44.173c0-.647-.527-1.17-1.17-1.17h-1.561v-2.632c0-.647-.527-1.174-1.17-1.174H64.998c-.651 0-1.17.527-1.17 1.174v51.221a14.537 14.537 0 0 1-5.262.985c-4.043 0-7.732-1.685-10.55-4.453v-58.491l9.72-11.633h322.521l10.504 12.573v56.75c-2.899 3.25-6.901 5.254-11.328 5.254Z",
    fill: "#A49848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.165 370.662H246.523a1.17 1.17 0 0 1-1.173-1.169v-2.633h99.546c.647 0 1.17-.527 1.17-1.17v-8.778h5.273v12.581c0 .643-.527 1.169-1.174 1.169Z",
    fill: "#B8AE78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.182 377.978c0 .643-.527 1.17-1.17 1.17H40.991c-.65 0-1.174-.527-1.174-1.17v-36.67c0-.65.523-1.169 1.174-1.169h356.021c.643 0 1.17.519 1.17 1.169v36.67Z",
    fill: "#DBBA9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.817 361.592v16.387c0 .643.523 1.169 1.174 1.169h356.021c.643 0 1.17-.526 1.17-1.169v-16.387H39.817Z",
    fill: "#BB9475"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.817 373.295v4.682c0 .644.523 1.17 1.174 1.17h356.021c.643 0 1.17-.526 1.17-1.17v-4.682H39.817Z",
    fill: "#B38B68"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M398.182 348.135v-6.827c0-.65-.527-1.169-1.17-1.169H40.991c-.65 0-1.174.519-1.174 1.169v6.827h358.365Z",
    fill: "#E2DCC2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 366,
    width: 438,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 366.075h438v14.687H0v-14.687Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438 379.54a1.17 1.17 0 0 1-1.17 1.169H1.173c-.65 0-1.173-.522-1.173-1.169v-11.509c0-.643.523-1.17 1.173-1.17H436.83c.643 0 1.17.527 1.17 1.17v11.509Z",
    fill: "#DBBA9E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 376,
    width: 438,
    height: 5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 376.667h438v4.096H0v-4.096Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 377.197v2.343c0 .647.523 1.17 1.173 1.17H436.83c.643 0 1.17-.523 1.17-1.17v-2.343H0Z",
    fill: "#BB9475"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 366,
    width: 438,
    height: 5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 366.075h438v4.814H0v-4.814Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438 370.175v-2.144c0-.643-.527-1.17-1.17-1.17H1.173c-.65 0-1.173.527-1.173 1.17v2.144h438Z",
    fill: "#E2DCC2"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M369.489 104.568c0 .643-.526 1.17-1.169 1.17H67.728c-.643 0-1.17-.527-1.17-1.17V19.264c0-.643.527-1.17 1.17-1.17H368.32c.643 0 1.169.527 1.169 1.17v85.304Z",
    fill: "#242023"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 0,
    width: 278,
    height: 80
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M79 .486h278v79H79v-79Z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDB0B6",
    d: "M79.717.543h276.45v79.021H79.717z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBBA9E",
    d: "M48 94.486h341v48H48z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M351.338 356.913h-5.273V236.44c.422.034.847.053 1.279.053 1.377 0 2.716-.192 3.994-.556v120.976Z",
    fill: "#A49848"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M347.344 236.493c-.432 0-.857-.019-1.279-.053v-49.521h4.1c.647 0 1.173.523 1.173 1.17v47.847a14.518 14.518 0 0 1-3.994.557Z",
    fill: "#978D41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346.065 365.692a1.17 1.17 0 0 1-1.169 1.169H241.25a1.17 1.17 0 0 1-1.17-1.169V184.287c0-.647.523-1.174 1.17-1.174h103.646c.647 0 1.169.527 1.169 1.174v181.405Z",
    fill: "#DBBA9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M337.87 365.777c0 .598-.443 1.084-.993 1.084h-87.609c-.549 0-.989-.486-.989-1.084V197.656c0-.598.44-1.083.989-1.083h87.609c.55 0 .993.485.993 1.083v168.121Z",
    fill: "#492628"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.089 236.493c-.963 0-1.9-.109-2.81-.294v-38.543c0-.598.44-1.083.989-1.083h87.609c.55 0 .993.485.993 1.083v35.343c-3.979-3.269-6.57-8.53-6.57-14.476 0 5.976-2.603 11.268-6.604 14.536v-23.612h-63.242v22.788c-2.794 2.659-6.42 4.258-10.365 4.258Z",
    fill: "#381F22"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M337.87 201.839v-4.183c0-.598-.443-1.083-.993-1.083h-87.609c-.545 0-.989.485-.989 1.083v4.183h89.591Z",
    fill: "#25171A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M228.173 323.85H124.576c.997-.873 2.038-2.039 3.114-3.566 0 0 .041-.094.128-.236h97.625c.643 0 1.169-.527 1.169-1.174v-84.525a16.447 16.447 0 0 0 2.731-2.087v90.418c0 .643-.527 1.17-1.17 1.17Zm-113.925 0h-2.302l1.479-.504.541.184s.102.124.282.32Zm-2.377 0h-7.86a21.7 21.7 0 0 0-.433-.576c.128-1.188.034-2.264-.237-3.226h11.426a5.592 5.592 0 0 0-.496 1.139s-.572 1.753-1.572 1.918l.255.083c-.425.256-.801.478-1.083.662Zm-16.514 0H67.728c-.643 0-1.17-.527-1.17-1.17v-1.839c.888.087 1.813.124 2.765.124 2.922 0 6.1-.372 9.203-.917h14.367c.689 1.797 1.542 3.012 2.464 3.802Z",
    fill: "#A49848"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.612 234.349v-47.43h1.561c.643 0 1.17.523 1.17 1.17v44.173a16.447 16.447 0 0 1-2.731 2.087Z",
    fill: "#978D41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M226.612 318.875c0 .646-.526 1.173-1.169 1.173H64.998a1.17 1.17 0 0 1-1.17-1.173V184.287a1.17 1.17 0 0 1 1.17-1.174h160.445c.643 0 1.169.527 1.169 1.174v134.588Z",
    fill: "#DBBA9E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.49 233.315s9.854 5.522 10.25 18.869c0 0-12.747-5.303-10.25-18.869Z",
    fill: "#409841"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.12 226.594s9.854 5.521 10.249 18.873c0 0-12.746-5.307-10.249-18.873Z",
    fill: "#37773A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.805 236.794s9.853 5.521 10.252 18.873c0 0-12.75-5.307-10.252-18.873Z",
    fill: "#37773A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.033 210.185s-10.674 3.689-13.43 16.759c0 0 13.49-2.968 13.43-16.759ZM50.898 225.037s-10.67 3.69-13.43 16.759c0 0 13.487-2.967 13.43-16.759Z",
    fill: "#409841"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.096 233.677s-7.74 8.221-4.103 21.076c0 0 10.56-8.887 4.103-21.076ZM52.895 219.76s9.846 5.517 10.244 18.869c0 0-12.745-5.303-10.245-18.869Z",
    fill: "#409841"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.572 210.956s10.564 3.987 12.952 17.131c0 0-13.4-3.343-12.953-17.131ZM50.837 220.114s-7.285 2.52-9.169 11.441c0 0 9.207-2.023 9.17-11.441Z",
    fill: "#37773A"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.421 209.105s-6.018 9.55.015 21.468c0 0 8.665-10.745-.015-21.468Z",
    fill: "#2B4E2C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M50.322 227.617s-6.013 9.549.02 21.468c0 0 8.665-10.745-.02-21.468Z",
    fill: "#2B4E2C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.24 220.389s-6.812 5.495-5.387 15.755c0 0 9.057-5.713 5.386-15.755ZM54.084 235.666s6.615 5.728 4.829 15.928c0 0-8.85-6.018-4.83-15.928Z",
    fill: "#2B4E2C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M55.99 199.391s9.854 5.517 10.253 18.865c0 0-12.75-5.303-10.253-18.865Z",
    fill: "#409841"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M50.62 192.67s9.854 5.517 10.253 18.865c0 0-12.75-5.303-10.253-18.865Z",
    fill: "#37773A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.307 202.869s9.854 5.514 10.25 18.865c0 0-12.75-5.303-10.25-18.865Z",
    fill: "#37773A"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.533 176.253s-10.67 3.689-13.427 16.763c0 0 13.487-2.968 13.427-16.763ZM50.401 191.109s-10.673 3.686-13.426 16.763c0 0 13.487-2.967 13.426-16.763Z",
    fill: "#409841"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.595 199.748s-7.736 8.222-4.103 21.073c0 0 10.569-8.884 4.103-21.073ZM52.395 185.828s9.853 5.521 10.252 18.873c0 0-12.75-5.303-10.252-18.873Z",
    fill: "#409841"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M52.075 177.027s10.569 3.987 12.957 17.132c0 0-13.4-3.34-12.957-17.132ZM50.341 186.186s-7.289 2.519-9.17 11.444c0 0 9.212-2.027 9.17-11.444Z",
    fill: "#37773A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.925 175.174s-6.018 9.553.019 21.471c0 0 8.661-10.745-.02-21.471Z",
    fill: "#2B4E2C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.83 193.689s-6.021 9.55.011 21.468c0 0 8.666-10.749-.01-21.468Z",
    fill: "#2B4E2C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M48.738 186.46s-6.81 5.495-5.378 15.751c0 0 9.053-5.713 5.378-15.751ZM53.584 201.741s6.619 5.721 4.836 15.924c0 0-8.853-6.017-4.837-15.924Z",
    fill: "#2B4E2C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M237.207 233.052s9.854 5.517 10.253 18.873c0 0-12.75-5.304-10.253-18.873Z",
    fill: "#409841"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M231.837 226.331s9.854 5.517 10.252 18.873c0 0-12.749-5.303-10.252-18.873Z",
    fill: "#37773A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M232.524 236.531s9.854 5.518 10.253 18.873c0 0-12.75-5.303-10.253-18.873Z",
    fill: "#37773A"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M232.754 209.918s-10.674 3.69-13.427 16.759c0 0 13.483-2.967 13.427-16.759ZM231.618 224.77s-10.674 3.689-13.43 16.766c0 0 13.49-2.971 13.43-16.766Z",
    fill: "#409841"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M228.812 233.412s-7.736 8.218-4.103 21.077c0 0 10.565-8.887 4.103-21.077ZM233.611 219.497s9.854 5.517 10.253 18.873c0 0-12.75-5.307-10.253-18.873Z",
    fill: "#409841"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M233.292 210.696s10.565 3.987 12.953 17.128c0 0-13.397-3.344-12.953-17.128ZM231.558 219.847s-7.289 2.52-9.169 11.448c0 0 9.21-2.023 9.169-11.448Z",
    fill: "#37773A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M233.142 208.838s-6.018 9.553.015 21.475c0 0 8.661-10.749-.015-21.475Z",
    fill: "#2B4E2C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M231.047 227.35s-6.022 9.556.011 21.471c0 0 8.666-10.745-.011-21.471Z",
    fill: "#2B4E2C"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M229.956 220.125s-6.811 5.499-5.378 15.751c0 0 9.053-5.705 5.378-15.751ZM234.8 235.406s6.62 5.725 4.837 15.928c0 0-8.853-6.021-4.837-15.928Z",
    fill: "#2B4E2C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M236.715 199.123s9.854 5.517 10.245 18.869c0 0-12.742-5.303-10.245-18.869Z",
    fill: "#409841"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M231.344 192.403s9.854 5.521 10.245 18.873c0 0-12.742-5.303-10.245-18.873Z",
    fill: "#37773A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M232.027 202.603s9.851 5.517 10.249 18.872c0 0-12.746-5.306-10.249-18.872Z",
    fill: "#37773A"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M232.258 175.993s-10.678 3.686-13.431 16.759c0 0 13.487-2.967 13.431-16.759ZM231.122 190.846s-10.674 3.689-13.431 16.759c0 0 13.487-2.968 13.431-16.759Z",
    fill: "#409841"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M228.319 199.484s-7.74 8.222-4.107 21.077c0 0 10.565-8.887 4.107-21.077ZM233.115 185.569s9.854 5.518 10.249 18.873c0 0-12.75-5.307-10.249-18.873Z",
    fill: "#409841"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M232.792 176.769s10.568 3.982 12.957 17.127c0 0-13.401-3.343-12.957-17.127ZM231.066 185.922s-7.293 2.516-9.173 11.441c0 0 9.207-2.024 9.173-11.441Z",
    fill: "#37773A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M232.641 174.914s-6.014 9.549.019 21.468c0 0 8.665-10.745-.019-21.468Z",
    fill: "#2B4E2C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M230.546 193.422s-6.018 9.553.015 21.475c0 0 8.665-10.749-.015-21.475Z",
    fill: "#2B4E2C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M229.463 186.197s-6.815 5.499-5.386 15.751c0 0 9.053-5.709 5.386-15.751ZM234.304 201.475s6.62 5.728 4.837 15.927c0 0-8.854-6.017-4.837-15.927Z",
    fill: "#2B4E2C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M357.387 231.065s9.854 5.518 10.249 18.873c0 0-12.747-5.303-10.249-18.873Z",
    fill: "#409841"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M352.016 224.353s9.853 5.517 10.252 18.865c0 0-12.75-5.303-10.252-18.865Z",
    fill: "#37773A"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M352.7 234.552s9.854 5.517 10.253 18.865c0 0-12.75-5.303-10.253-18.865Z",
    fill: "#37773A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M352.93 207.939s-10.674 3.69-13.431 16.76c0 0 13.491-2.968 13.431-16.76ZM351.794 222.792s-10.67 3.686-13.431 16.759c0 0 13.487-2.967 13.431-16.759Z",
    fill: "#409841"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M348.992 231.435s-7.74 8.214-4.103 21.073c0 0 10.561-8.888 4.103-21.073ZM353.791 217.512s9.846 5.517 10.245 18.872c0 0-12.746-5.303-10.245-18.872Z",
    fill: "#409841"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M353.468 208.711s10.565 3.987 12.953 17.131c0 0-13.401-3.343-12.953-17.131ZM351.734 217.869s-7.285 2.516-9.17 11.445c0 0 9.207-2.027 9.17-11.445Z",
    fill: "#37773A"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M353.318 206.86s-6.018 9.55.015 21.468c0 0 8.665-10.741-.015-21.468Z",
    fill: "#2B4E2C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M351.219 225.364s-6.014 9.557.019 21.476c0 0 8.665-10.749-.019-21.476Z",
    fill: "#2B4E2C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M350.136 218.143s-6.812 5.494-5.386 15.747c0 0 9.056-5.706 5.386-15.747ZM354.979 233.42s6.616 5.728 4.829 15.928c0 0-8.849-6.014-4.829-15.928Z",
    fill: "#2B4E2C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M356.887 197.142s9.854 5.517 10.252 18.869c0 0-12.75-5.303-10.252-18.869Z",
    fill: "#409841"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M351.516 190.424s9.853 5.513 10.252 18.869c0 0-12.75-5.303-10.252-18.869Z",
    fill: "#37773A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M352.204 200.62s9.854 5.518 10.249 18.873c0 0-12.75-5.311-10.249-18.873Z",
    fill: "#37773A"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M352.429 174.008s-10.67 3.689-13.427 16.759c0 0 13.487-2.968 13.427-16.759ZM351.297 188.867s-10.674 3.682-13.427 16.755c0 0 13.487-2.963 13.427-16.755Z",
    fill: "#409841"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M348.495 197.503s-7.74 8.218-4.107 21.073c0 0 10.569-8.887 4.107-21.073ZM353.291 183.587s9.854 5.517 10.253 18.869c0 0-12.75-5.303-10.253-18.869Z",
    fill: "#409841"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M352.971 174.786s10.568 3.987 12.956 17.128c0 0-13.4-3.34-12.956-17.128ZM351.237 183.937s-7.289 2.519-9.17 11.448c0 0 9.211-2.027 9.17-11.448Z",
    fill: "#37773A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M352.82 172.929s-6.017 9.556.019 21.475c0 0 8.662-10.749-.019-21.475Z",
    fill: "#2B4E2C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M350.726 191.439s-6.022 9.553.011 21.472c0 0 8.665-10.745-.011-21.472Z",
    fill: "#2B4E2C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M349.635 184.212s-6.811 5.499-5.378 15.755c0 0 9.052-5.709 5.378-15.755ZM354.479 199.496s6.619 5.724 4.837 15.92c0 0-8.854-6.013-4.837-15.92Z",
    fill: "#2B4E2C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M220.174 312.251c0 .579-.485 1.057-1.083 1.057H71.343a1.07 1.07 0 0 1-1.075-1.057V190.909c0-.583.481-1.056 1.075-1.056h147.748c.598 0 1.083.473 1.083 1.056v121.342Z",
    fill: "#5CA1CD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M219.091 189.853H71.343c-.594 0-1.075.473-1.075 1.056v39.89c2.692-3.216 4.347-7.526 4.347-12.276 0 9.925 7.176 17.97 16.037 17.97 8.861 0 16.045-8.045 16.045-17.97 0 9.925 7.183 17.97 16.044 17.97s16.045-8.045 16.045-17.97c0 9.925 7.179 17.97 16.04 17.97 8.861 0 16.045-8.045 16.045-17.97 0 9.925 7.187 17.97 16.044 17.97 8.858 0 16.041-8.045 16.041-17.97 0 9.925 7.184 17.97 16.045 17.97.394 0 .782-.03 1.173-.064v-45.52c0-.583-.485-1.056-1.083-1.056Z",
    fill: "#397193"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M75.461 297.166a.891.891 0 0 1-.902-.88v-76.292c.037-.485.056-.978.056-1.471 0 9.926 7.176 17.971 16.037 17.971 8.86 0 16.044-8.045 16.044-17.971 0 9.926 7.184 17.971 16.045 17.971s16.044-8.045 16.044-17.971c0 8.109 4.792 14.969 11.381 17.203l-74.705 61.44Zm95.41-78.466v-.177.177Z",
    fill: "#83B0CD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M122.741 236.493c-8.861 0-16.045-8.045-16.045-17.97 0 9.925-7.183 17.97-16.044 17.97s-16.037-8.045-16.037-17.97c0 .493-.019.985-.056 1.471v-24.823c0-.485.402-.884.902-.884h123.117c.5 0 .903.399.903.884l-28.61 23.529v-.177.177l-20.705 17.026c-6.589-2.234-11.381-9.094-11.381-17.203 0 9.925-7.183 17.97-16.044 17.97Z",
    fill: "#6B8EA6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m94.86 287.474 9.004-7.654c-.041.256-.09.538-.158.842l-8.846 6.812Zm10.057-7.744c-.146-.169-.286-.327-.402-.459l50.356-42.778c7.33-.022 13.498-5.544 15.394-13.081l1.012-.853a19.165 19.165 0 0 0 1.662 4.791l-68.022 52.38Z",
    fill: "#83B0CD"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m154.871 236.493 15.394-13.081c-1.896 7.537-8.064 13.059-15.394 13.081Zm18.068-9.143a19.165 19.165 0 0 1-1.662-4.791l33.277-28.272h11.321l-42.936 33.063Z",
    fill: "#6B8EA6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M261.454 278.789h63.242v-69.342h-63.242v69.342Z",
    fill: "#5CA1CD"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M261.454 232.224c3.468-3.298 5.672-8.207 5.672-13.701 0 9.925 7.179 17.97 16.044 17.97 8.861 0 16.045-8.045 16.045-17.97 0 9.925 7.183 17.97 16.04 17.97 3.532 0 6.789-1.294 9.441-3.457v-23.589h-63.242v22.777Z",
    fill: "#397193"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M265.848 263.283v-37.715a19.791 19.791 0 0 0 1.278-7.045c0 9.926 7.18 17.971 16.045 17.971 8.861 0 16.044-8.045 16.044-17.971 0 4.062 1.2 7.816 3.239 10.825l-36.606 33.935Z",
    fill: "#83B0CD"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M283.171 236.493c-8.865 0-16.045-8.045-16.045-17.97 0 2.501-.455 4.882-1.278 7.044v-12.219h53.869l-17.263 15.999c-2.039-3.009-3.239-6.762-3.239-10.824 0 9.925-7.183 17.97-16.044 17.97Z",
    fill: "#6B8EA6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m265.848 267.183 38.257-35.741a16.123 16.123 0 0 0 4.829 3.603l-43.086 32.138Z",
    fill: "#83B0CD"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M308.933 235.045a16.156 16.156 0 0 1-4.829-3.603l15.611-14.586v10.148l-10.782 8.041Z",
    fill: "#6B8EA6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M63.775 286.488s-3.276 16.707-.11 25.105c0 0 2.972-4.412.11-25.105Z",
    fill: "#42A647"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M57.442 288.715s.854 17.003 5.954 24.39c0 0 1.817-4.995-5.954-24.39Z",
    fill: "#42A647"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M52.65 291.843s4.138 16.511 10.576 22.765c0 0 .813-5.246-10.576-22.765Z",
    fill: "#42A647"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M47.216 296.286s8.165 14.943 15.97 19.377c0 0-.535-5.284-15.97-19.377ZM40.51 302.189S53.797 314.59 63.2 316.47c0 0-2.313-5.179-22.69-14.281ZM37.505 309.568s16.394 8.658 26.154 7.996c0 0-3.67-4.479-26.154-7.996Z",
    fill: "#42A647"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M32.408 314.271s19.858 7.376 30.81 5.172c0 0-4.817-4.521-30.81-5.172Z",
    fill: "#42A647"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M38.573 322.375s16.902 2.129 25.071-1.602c0 0-4.607-2.663-25.07 1.602Z",
    fill: "#42A647"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M43.933 329.766s13.915-3.016 19.316-8.229c0 0-4.366-.82-19.316 8.229Z",
    fill: "#42A647"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M54.227 331.429s7.995-3.697 9.007-8.662c0 0-3.426-.384-9.007 8.662ZM70.425 289.839s-1 16.996-6.164 24.337c0 0-1.768-5.009 6.164-24.337Z",
    fill: "#42A647"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M75.19 293.005s-4.277 16.473-10.768 22.679c0 0-.771-5.258 10.768-22.679Z",
    fill: "#42A647"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M80.583 297.493s-8.29 14.871-16.13 19.245c0 0 .582-5.28 16.13-19.245Z",
    fill: "#42A647"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M87.244 303.45s-13.393 12.295-22.814 14.096c0 0 2.362-5.163 22.814-14.096Z",
    fill: "#42A647"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M90.181 310.855s-16.466 8.519-26.214 7.778c0 0 3.7-4.449 26.214-7.778Z",
    fill: "#42A647"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M95.24 315.605s-19.922 7.203-30.851 4.912c0 0 4.855-4.487 30.851-4.912Z",
    fill: "#42A647"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M89.004 323.658s-16.917 1.982-25.048-1.816c0 0 4.622-2.618 25.048 1.816Z",
    fill: "#42A647"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M83.589 330.999s-13.894-3.137-19.253-8.395c0 0 4.378-.782 19.253 8.395Z",
    fill: "#42A647"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M73.283 332.256s-7.966-3.761-8.936-8.74c0 0 3.434-.358 8.936 8.74Z",
    fill: "#42A647"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M67.521 354.814c.105-.768-.839-5.04-.839-5.04-.857-2.648-1.466-13.216-1.466-13.216.007-22.589-1.242-24.624-1.46-27.463v-.407l-.011.204a4.268 4.268 0 0 1-.019-.204v.407c-.237 2.839-1.143 13.46-.929 27.448 0 0-.7 10.572-1.572 13.208 0 0-.718 2.343-.508 3.641 0 0 3.916-.252 5.653 1.41 0 0 .482.403 1.151.012Z",
    fill: "#2A512E"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M74.96 367.2H52.691l-2.456-30.656h27.181L74.96 367.2Z",
    fill: "#BC4641"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m76.9 342.96.516-6.416h-27.18l.51 6.416h26.155Z",
    fill: "#9C3534"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M79.147 338.928c0 .323-.26.583-.583.583H49.089a.582.582 0 0 1-.587-.583v-3.81c0-.327.26-.591.587-.591h29.475c.323 0 .583.264.583.591v3.81Z",
    fill: "#BC4641"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M79.147 336.148v-1.03a.586.586 0 0 0-.583-.591H49.089a.586.586 0 0 0-.587.591v1.03h30.645Z",
    fill: "#DB615D"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "m52.537 365.296.154 1.903h22.27l.15-1.903H52.537Z",
    fill: "#9C3534"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M115.504 300.486s-3.678 1.651-4.622 2.701l-.429.932s2.877-2.437 5.232-2.817l-.181-.816Z",
    fill: "#1C4622"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M126.081 292.649s-10.956-.151-11.133 8.27c0 0 4.664 5.961 9.869.515 0 0 2.494-2.422 3.953-5.201 0 0 1.061-2.437 2.753-3.419 0 0-2.753.301-5.442-.165Z",
    fill: "#35AB41"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M123 296.763c-.17 0-.26-.012-.26-.012l.971-.538c.064.004.127.008.195.008 1.568 0 4.976-1.207 4.976-1.207-2.794 1.602-5.126 1.749-5.882 1.749ZM122.24 298.606c-.993 0-1.572-.285-1.861-.488l.372-.362.252-.06c.538.203.858.497 1.568.497.158 0 .339-.012.546-.049.207-.034.444-.045.68-.045 1.211 0 2.611.368 2.611.368a21.249 21.249 0 0 0-1.554-.064c-1.102 0-1.609.117-1.609.117a5.967 5.967 0 0 1-1.005.086Zm-1.974-.579a1.065 1.065 0 0 1-.12-.116l.105-.027c.004.053.011.106.015.143Z",
    fill: "#25692E"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M121.875 300.61c-2.854 0-3.227-1.576-3.227-1.576l.399-.225c.087 1.474 3.46 1.591 4.543 1.591.207 0 .331-.004.331-.004-.793.15-1.47.214-2.046.214Z",
    fill: "#23602B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M122.052 302.645s-2.189-1.437-3.148-1.346c-.951.086-1.771-1.422-1.771-1.422l-.455.256s.605 1.256 2.38 1.64c0 0 .896-.155 2.994.872Z",
    fill: "#1C4622"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M122.646 296.594s1.023-1.986 3.856-3.513c0 0-2.517 2.012-3.058 3.069l-.798.444Z",
    fill: "#2A7D34"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M120.3 298.188s-.023-.056-.034-.161c.03.03.068.056.113.09l-.079.071Zm-.049-.304c-.015-.418.117-1.223 1.016-2.264 0 0 .624-.629 1.493-2.317 0 0-.527 1.73-1.268 2.58-.654.748-.523 1.166-.635 1.775l-.106.098-.5.128Z",
    fill: "#23602B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M120.379 298.117c-.045-.034-.083-.06-.113-.09-.004-.038-.011-.091-.015-.143l.5-.128-.372.361Z",
    fill: "#1E5025"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M118.555 298.869s-1.456-1.46 1.421-4.566c0 0-2.331 3.479-1.075 4.374l-.346.192Z",
    fill: "#2A7D34"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M117.058 295.925s.045 1.798-.346 2.324c-.395.519.188 1.546.188 1.546l-.312.173s-.519-.809-.101-1.978c0 0 .417-.467.571-2.065Z",
    fill: "#1C4622"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M130.12 293.284s-9.429 3.054-15.172 7.635l.478.5s5.476-4.122 14.694-8.135Z",
    fill: "#1C4622"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M126.314 302.656s-15.774 4.57-12.175 14.785c0 0 8.534 3.829 9.866-6.292 0 0 1.327-7.447 2.309-8.493Z",
    fill: "#35AB41"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M117.156 312.886s3.708-4.652 8.282-9.413c0 0-4.954 3.772-9.031 9.316 0 0-1.914 3.17-2.753 4.979l.546.252s2.41-4.513 2.956-5.134Z",
    fill: "#1C4622"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M119.95 309.535c.207-.241.421-.493.651-.749 1.369-.361 4.28-2.58 4.28-2.58-2.197 2.403-4.397 3.167-4.931 3.329Z",
    fill: "#25692E"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m119.822 309.569.722-.774c.019 0 .038-.004.057-.008-.23.256-.444.508-.651.749l-.128.033Z",
    fill: "#1C4622"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M118.52 311.916c-.21 0-.387-.022-.534-.049l.542-.654c.263.034.508.079.771.079.331 0 .699-.068 1.207-.331 1.219-.624 3.404-.73 3.404-.73-2.242.519-3.156 1.065-3.156 1.065-.951.485-1.696.62-2.234.62Z",
    fill: "#25692E"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M117.987 311.867c-.079-.015-.147-.034-.211-.049l.274-.507.192-.124c.102.003.192.018.286.026l-.541.654Zm-.362-.105a1.002 1.002 0 0 1-.165-.083l.105-.067c.023.06.042.109.06.15Z",
    fill: "#1C4622"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M118.392 314.282c-.914 0-1.481-.297-1.801-.549.083-.139.162-.267.233-.376.338.349.929.47 1.598.47 1.685 0 3.897-.794 3.897-.794-1.73.948-3.001 1.249-3.927 1.249Z",
    fill: "#23602B"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M116.591 313.732a1.627 1.627 0 0 1-.297-.297l.196-.215c-.023-.003-.046-.015-.064-.022l.173-.188a1.1 1.1 0 0 0 .225.346c-.071.109-.15.237-.233.376ZM121.615 316.298s-2.82-.783-3.802-.361c-.985.413-2.369-.907-2.369-.907l-.399.425s1.076 1.129 3.088.933c0 0 .902-.47 3.482-.09Z",
    fill: "#1C4622"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M119.894 308.61c.327-.936 1.06-2.55 2.674-4.223 0 0-1.339 2.008-1.937 3.452-.241.249-.485.508-.737.771Z",
    fill: "#2A7D34"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M119.672 309.427s.049-.308.222-.816c.252-.263.496-.523.737-.771a4.36 4.36 0 0 0-.271.85l-.688.737Z",
    fill: "#1C4622"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M117.498 311.379c-.117-.489-.14-1.316.376-2.509h.003c.031 0 .196-.094.512-1.989 0 0 .312 1.03-.192 2.189-.331.767-.248 1.184-.154 1.636-.184.225-.361.444-.545.673Z",
    fill: "#23602B"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M117.72 311.924s-.038-.053-.094-.162c.045.019.094.038.15.056l-.056.106Zm-.154-.313a1.672 1.672 0 0 1-.068-.233c.184-.229.361-.447.545-.673.03.147.064.297.087.463l-.079.143-.485.3Z",
    fill: "#1C4622"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M117.776 311.818a2.217 2.217 0 0 1-.15-.056 2.575 2.575 0 0 1-.061-.151l.486-.3-.275.507Z",
    fill: "#1C4622"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M116.05 313.391c-.407-.354-1.305-1.557.124-4.626 0 0-1.001 3.486.06 4.321-.049.09-.113.188-.184.305Z",
    fill: "#2A7D34"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M116.219 313.515s-.071-.038-.169-.124c.071-.117.135-.215.184-.305.057.049.12.083.192.113l-.173.18s.015.019.041.057l-.075.079Z",
    fill: "#1C4622"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m116.294 313.436-.041-.056.173-.181c.019.008.041.019.064.023l-.196.214ZM114.391 311.589s.616 1.745.395 2.384c-.226.64.669 1.463.669 1.463l-.252.271s-.763-.632-.722-1.914c0 0 .263-.591-.09-2.204ZM109.141 318.096s2.621 2.151 4.513-.327l.545.252s-1.888 3.031-5.006 1.064l-.052-.989ZM109.404 325.445s1.651-.824 5.22-3.727l-.041.805s-3.46 3.339-5.311 3.704l.132-.782Z",
    fill: "#1C4622"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M125.704 315.558s-2.945-.192-4.777.767c0 0-5.355.669-6.657 4.863 0 0-.571 1.753-1.572 1.918l1.268.425s5.995 7.718 13.724-3.246c0 0 1.335-2.96 4.456-2.655 0 0-5.325-2.151-6.442-2.072Z",
    fill: "#35AB41"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M118.614 320.71s5.258-1.779 11.306-3.224c0 0-5.935.504-11.908 2.795 0 0-4.705 2.644-6.228 3.622l2.001-.681c3.058-1.723 2.971-1.978 4.829-2.512Z",
    fill: "#1C4622"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M124.904 319.755c-1.23 0-2.092-.188-2.396-.267.286-.087.583-.173.891-.263.527.15 1.38.195 2.227.195 1.312 0 2.602-.109 2.602-.109a12.833 12.833 0 0 1-3.324.444Z",
    fill: "#25692E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M122.508 319.487a13.01 13.01 0 0 0-.124-.034l.966-.244c.015.004.03.011.049.015-.308.09-.605.177-.891.263Z",
    fill: "#1C4622"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M125.606 321.924c-2.159-.673-3.193-.703-3.193-.703-1.429-.12-2.227-.557-2.633-.891.222-.076.482-.151.76-.241.474.342.812.681 1.817.76 1.32.105 3.249 1.075 3.249 1.075Z",
    fill: "#25692E"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M119.781 320.329c-.06-.049-.109-.097-.158-.143l.462-.255h.222c.083.056.158.105.234.158-.279.09-.538.165-.76.24Zm-.263-.252a1.084 1.084 0 0 1-.102-.146h.117c-.008.056-.008.105-.015.146Z",
    fill: "#1C4622"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M122.993 323.308c-3.965-.218-5.006-1.64-5.277-2.306.12-.048.248-.094.391-.139.41 1.542 4.886 2.445 4.886 2.445Z",
    fill: "#23602B"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M117.715 321.003a1.475 1.475 0 0 1-.086-.29l.259-.064c-.011-.019-.03-.03-.045-.049l.241-.06a.766.766 0 0 0 .023.323 5.643 5.643 0 0 0-.392.14ZM120.932 325.472s-2.076-1.956-3.106-2.11c-1.031-.151-1.637-1.836-1.637-1.836l-.53.136s.421 1.384 2.242 2.204c0 0 .981.075 3.031 1.606Z",
    fill: "#1C4622"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M122.876 318.753c.692-.561 2.046-1.441 4.167-1.952 0 0-2.035.899-3.197 1.719-.316.071-.639.15-.97.233Z",
    fill: "#2A7D34"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M122.319 319.269s.177-.211.557-.515c.331-.083.654-.162.97-.233a3.425 3.425 0 0 0-.609.515l-.918.233ZM119.529 320.243s-.011-.061-.011-.166c.033.034.067.068.105.109l-.094.057Z",
    fill: "#1C4622"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M119.577 319.716c.121-.429.467-1.076 1.441-1.742 0 0 .007.004.018.004.061 0 .309-.109 1.309-1.279 0 0-.192.94-1.139 1.587-.625.429-.741.79-.858 1.181-.256.079-.515.162-.771.249Z",
    fill: "#23602B"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M120.085 319.931h-.553c.012-.064.023-.131.045-.214.256-.087.516-.169.771-.248-.041.124-.079.255-.139.395l-.124.067ZM119.623 320.186c-.038-.041-.072-.075-.105-.109.007-.041.007-.09.015-.146h.552l-.462.255Z",
    fill: "#1C4622"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M117.457 320.593c-.196-.433-.504-1.813 2.151-3.513 0 0-2.437 2.208-1.869 3.355-.083.045-.177.101-.282.158Z",
    fill: "#2A7D34"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M117.528 320.735s-.031-.045-.072-.142c.105-.057.199-.113.282-.158.03.06.064.109.105.165l-.221.053s0 .022.007.06l-.101.022Z",
    fill: "#1C4622"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M117.63 320.713c-.008-.037-.008-.06-.008-.06l.222-.052c.015.018.034.03.045.048l-.259.064ZM116.817 318.385s-.248 1.632-.726 2.016c-.477.383-.071 1.444-.071 1.444l-.339.09s-.376-.857.233-1.816c0 0 .486-.331.903-1.734Z",
    fill: "#1C4622"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M103.92 278.62s11.543 11.674 3.423 18.839c0 0-9.324-.812-5.552-10.298 0 0 2.471-7.149 2.129-8.541Z",
    fill: "#35AB41"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M106.925 292.017s-.97-5.875-2.644-12.257c0 0 2.49 5.705 3.34 12.535 0 0 .132 3.705-.019 5.694l-.598-.048s.094-5.115-.079-5.924Z",
    fill: "#1C4622"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M106.121 287.729c-.395-.402-1.941-2.143-2.685-5.314 0 0 1.463 3.362 2.482 4.34.075.339.139.662.203.974Z",
    fill: "#25692E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M106.21 287.815s-.03-.026-.09-.086c-.064-.312-.128-.636-.203-.974.015.015.03.026.041.037l.252 1.023ZM107.216 290.81c-.034 0-.091 0-.154-.007.037-.03.079-.06.127-.102l.061.109h-.034Z",
    fill: "#1C4622"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M106.7 290.72c-.511-.165-1.316-.617-2.14-1.847 0 0-.538-.921-2.238-2.471 0 0 1.858 1.162 2.614 2.298.576.862 1.053.963 1.606 1.181.06.312.113.591.158.839Z",
    fill: "#25692E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M106.903 290.772a2.104 2.104 0 0 1-.203-.052 78.586 78.586 0 0 0-.158-.839c.086.037.173.075.26.12l.109.2-.008.571Z",
    fill: "#1C4622"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M106.655 293.055c-.91 0-2.49-.526-4.31-3.43 0 0 2.617 3.009 4.302 3.009.117 0 .23-.019.339-.049.007.135.011.282.019.444a1.966 1.966 0 0 1-.35.026Z",
    fill: "#23602B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M107.004 293.029c-.007-.162-.011-.308-.019-.444.132-.037.252-.101.365-.191l.06.252c-.022-.008-.045-.008-.067-.012l.067.279c-.067.033-.21.082-.406.116ZM101.367 292.822s2.847.692 3.502 1.531c.65.846 2.505.365 2.505.365l.142.564s-1.493.47-3.151-.685c0 0-.561-.846-2.998-1.775Z",
    fill: "#1C4622"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M106.618 286.943c-.087-.353-.177-.695-.264-1.03.177-1.554-.003-3.953-.003-3.953.583 2.245.443 4.013.267 4.983Z",
    fill: "#2A7D34"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m106.418 287.77-.244-.985c.079-.226.139-.531.18-.873.087.335.177.677.264 1.031-.094.534-.2.827-.2.827ZM106.903 290.896v-.125c.06.016.113.023.158.031-.098.071-.158.094-.158.094Z",
    fill: "#1C4622"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m107.365 290.532-.15-.85c.301-.354.579-.677.662-1.508.128-1.253.902-2.005.902-2.005-.71 1.971-.526 1.986-.522 1.986-.132 1.294-.553 2.001-.892 2.377Z",
    fill: "#23602B"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m107.188 290.7-.278-.5.004-.158c.098-.132.199-.249.301-.361l.15.85a2.39 2.39 0 0 1-.177.169Z",
    fill: "#1C4622"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M107.061 290.802c-.045-.008-.098-.015-.158-.03l.008-.572.278.5c-.049.042-.09.072-.128.102Z",
    fill: "#1C4622"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M107.644 292.991c-.004-.132-.011-.252-.011-.353 1.331-.215 2.162-3.746 2.162-3.746-.248 3.377-1.624 3.99-2.151 4.099Z",
    fill: "#2A7D34"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M107.441 293.017h-.004l-.026-.106.06-.026-.06-.241c.03.004.064.004.094.004a.82.82 0 0 0 .128-.011c0 .101.008.222.011.353-.105.023-.18.027-.203.027Z",
    fill: "#1C4622"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m107.411 292.911-.067-.278c.022.004.045.004.067.011l.061.241s-.019.007-.061.026ZM109.972 292.224s-1.392 1.229-1.505 1.895c-.12.67-1.301.948-1.301.948l.087.361s.977-.184 1.564-1.32c0 0 .06-.643 1.155-1.884ZM111.386 300.46s-3.339.61-3.783-2.471l-.598-.049s.169 3.562 3.851 3.367l.53-.847ZM109.799 307.79s-1.226-1.373-3.471-5.386l-.26.76s1.979 4.378 3.566 5.401l.165-.775Z",
    fill: "#1C4622"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M98.309 292.58s2.809.907 4.159 2.483c0 0 4.728 2.598 4.382 6.976 0 0-.117 1.836.752 2.358l-1.331-.071s-8.429 4.953-11.558-8.086c0 0-.139-3.246-3.151-4.115 0 0 5.743-.026 6.747.455Z",
    fill: "#35AB41"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M102.996 299.99s-4.232-3.6-9.32-7.173c0 0 5.337 2.659 10.034 6.996 0 0 2.287 2.527 3.34 4.002l-.5.293s-2.941-3.648-3.554-4.118Z",
    fill: "#1C4622"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M99.829 297.418c-.55-.076-2.799-.459-5.25-2.283 0 0 3.128 1.568 4.52 1.704.252.199.496.391.73.579Z",
    fill: "#25692E"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "m99.956 297.429-.128-.011c-.233-.188-.477-.38-.73-.579.02.007.03.007.05.007l.808.583Z",
    fill: "#1C4622"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M101.021 299.351c-.467 0-1.046-.076-1.75-.29 0 0-.97-.357-3.226-.527 0 0 .523-.045 1.203-.045.707 0 1.576.053 2.216.248.376.113.669.155.925.155.399 0 .699-.106 1.045-.192.23.184.437.353.613.504a3.3 3.3 0 0 1-1.026.147Z",
    fill: "#25692E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M102.048 299.204c-.177-.151-.384-.32-.613-.504.086-.023.18-.042.274-.06l.203.082.335.407c-.056.03-.12.052-.199.075Zm.338-.139c.015-.042.03-.087.041-.14l.11.046s-.049.041-.151.094Z",
    fill: "#1C4622"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M101.258 301.416c-.835 0-1.907-.169-3.291-.632 0 0 1.406.26 2.813.26 1.076 0 2.155-.154 2.595-.685.087.087.177.188.278.297-.346.328-1.056.76-2.395.76Z",
    fill: "#23602B"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M103.653 300.655c-.101-.109-.191-.21-.278-.297a.871.871 0 0 0 .177-.331l.199.14-.064.033.218.155a1.326 1.326 0 0 1-.252.3ZM99.08 303.56s2.652-1.057 3.667-.816c1.012.24 2.196-1.098 2.196-1.098l.444.319s-.899 1.136-2.896 1.215c0 0-.94-.29-3.41.38Z",
    fill: "#1C4622"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M99.757 296.597c-.274-.199-.549-.395-.816-.579-.77-1.189-2.335-2.776-2.335-2.776 1.786 1.256 2.715 2.576 3.151 3.355Z",
    fill: "#2A7D34"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "m100.085 297.281-.771-.556c-.068-.2-.203-.444-.373-.707.267.184.542.379.816.579.241.425.328.684.328.684Z",
    fill: "#1C4622"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M102.465 298.712c-.211-.177-.417-.35-.621-.516.034-.41.057-.789-.364-1.414-.64-.951-.47-1.895-.47-1.895.541 1.583.718 1.673.756 1.673.003 0 .003-.003.003-.003.658.981.741 1.711.696 2.155Z",
    fill: "#23602B"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "m102.319 299.218-.072-.09c.053-.023.098-.045.139-.064-.034.102-.067.154-.067.154Zm.109-.293-.516-.203-.094-.113c0-.147.015-.286.027-.414.203.166.41.339.62.516a1.41 1.41 0 0 1-.037.214Z",
    fill: "#1C4622"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "m102.247 299.129-.335-.406.515.203a1.006 1.006 0 0 1-.041.139l-.139.064Z",
    fill: "#1C4622"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M104.139 300.29c-.083-.094-.154-.177-.218-.244.929-.869-.504-3.803-.504-3.803 1.798 2.509 1.072 3.682.722 4.047Z",
    fill: "#2A7D34"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m103.988 300.414-.083-.06a.512.512 0 0 0 .034-.049l-.188-.139a.642.642 0 0 0 .169-.12c.064.068.136.15.218.244-.086.087-.15.124-.15.124Z",
    fill: "#1C4622"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m103.906 300.355-.218-.154.063-.034.188.139s-.011.019-.033.049ZM105.527 298.493s-.376 1.61-.075 2.148c.301.53-.467 1.365-.467 1.365l.279.199s.665-.647.459-1.767c0 0-.331-.486-.196-1.945ZM105.278 312.292s2.776 2.922 3.25 4.246l.041 1.031s-1.734-3.351-3.772-4.596l.481-.681Z",
    fill: "#1C4622"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M98.471 301.025s10.196 4.016 7.154 11.869c0 0-6.578 3.75-9.328-3.26 0 0-1.38-3.194-1.677-6.315 0 0-.049-2.663-1.245-4.213 0 0 2.433 1.328 5.096 1.919Z",
    fill: "#35AB41"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M99.999 306.094s-2.603-.839-5.021-3.946c0 0 2.94 2.629 4.332 3.073l.689.873ZM101.16 308.298c-.519 0-1.294-.154-2.294-.771 0 0-.828-.579-2.915-1.245 0 0 2.069.267 3.17.948.561.35.952.417 1.317.417.12 0 .237-.007.361-.018.12-.004.245-.015.376-.015h.079l.203.158.211.47a2.011 2.011 0 0 1-.508.056Zm.647-.094c.023-.034.041-.075.068-.128l.086.068s-.052.03-.154.06Z",
    fill: "#25692E"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M101.223 310.412c-.846 0-2.05-.32-3.7-1.403 0 0 2.21.996 3.757.996.62 0 1.136-.158 1.354-.613l.282.358s-.474.662-1.693.662Z",
    fill: "#23602B"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4 311.803s2.568-.5 3.418-.06c.854.444 2.185-.639 2.185-.639l.324.409s-1.038.933-2.829.614c0 0-.771-.478-3.099-.324Z",
    fill: "#1C4622"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m100.144 305.973-.56-.707c-.102-1.188-1.666-4.001-1.666-4.001 2.038 2.486 2.226 4.708 2.226 4.708Z",
    fill: "#2A7D34"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m101.713 308.343-.046-.102c.057-.007.098-.022.14-.037a1.311 1.311 0 0 1-.094.139Zm.161-.267-.417-.305-.053-.128c.124-.609.403-.947.087-1.884-.365-1.068-.192-2.877-.192-2.877.158 1.899.492 2.715.492 2.715.444 1.309.252 2.106.083 2.479Z",
    fill: "#23602B"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m101.668 308.243-.211-.471.418.305c-.027.053-.046.094-.068.128-.042.015-.083.03-.139.038Z",
    fill: "#1E5025"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m103.07 309.637-.252-.312c1.505-.346.67-4.453.67-4.453 1.485 3.968-.418 4.765-.418 4.765Z",
    fill: "#2A7D34"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M105.571 307.481s-.73 1.644-.56 2.28c.165.635-.764 1.357-.764 1.357l.226.279s.786-.553.842-1.794c0 0-.203-.591.256-2.122Z",
    fill: "#1C4622"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M94.492 300.077s7.567 6.405 11.133 12.818l-.628.289s-3.502-5.897-10.505-13.107Z",
    fill: "#1C4622"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M88.782 311.45s16.349 1.527 14.74 12.235c0 0-7.662 5.367-10.87-4.325 0 0-2.711-7.064-3.87-7.91Z",
    fill: "#35AB41"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7 319.781s-4.516-3.877-9.902-7.687c0 0 5.57 2.768 10.617 7.454 0 0 2.482 2.749 3.645 4.37l-.489.354s-3.216-3.983-3.87-4.491Z",
    fill: "#1C4622"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M96.327 317.008c-.56-.052-2.866-.391-5.469-2.339 0 0 3.276 1.632 4.69 1.73.271.207.53.414.779.609Z",
    fill: "#25692E"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M96.458 317.024s-.045-.004-.132-.015c-.248-.196-.507-.403-.778-.61h.052l.858.625Z",
    fill: "#1C4622"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M97.489 319.145c-.444 0-.982-.068-1.621-.256 0 0-1-.357-3.299-.451 0 0 .813-.117 1.742-.117.59 0 1.226.045 1.733.2.339.094.614.135.854.135.452 0 .767-.143 1.144-.259.24.195.462.379.654.537a3.253 3.253 0 0 1-1.207.211Z",
    fill: "#25692E"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M98.696 318.934c-.191-.158-.413-.342-.654-.538.087-.034.173-.056.267-.083l.218.087.361.444c-.056.026-.12.06-.192.09Zm.328-.169c.015-.045.022-.102.034-.158l.116.045s-.049.045-.15.113Z",
    fill: "#1C4622"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M97.779 321.469c-.809 0-1.828-.162-3.118-.579 0 0 1.125.18 2.37.18 1.248 0 2.61-.18 3.084-.891.09.094.191.207.3.323-.353.406-1.105.967-2.636.967Z",
    fill: "#23602B"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M100.415 320.503c-.109-.116-.21-.229-.301-.323.075-.117.128-.237.154-.38l.211.15a.285.285 0 0 0-.06.038l.233.169a1.604 1.604 0 0 1-.237.346ZM95.966 323.97s2.618-1.302 3.663-1.076c1.042.222 2.159-1.332 2.159-1.332l.466.339s-.842 1.316-2.854 1.501c0 0-.975-.294-3.434.568Z",
    fill: "#1C4622"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M96.202 316.091a38.94 38.94 0 0 0-.865-.617c-.86-1.309-2.542-3.028-2.542-3.028 1.888 1.339 2.918 2.791 3.407 3.645Z",
    fill: "#2A7D34"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m96.583 316.85-.82-.594a4 4 0 0 0-.425-.782c.282.195.572.402.865.616.27.471.38.76.38.76Z",
    fill: "#1C4622"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M99.08 318.359c-.222-.188-.44-.368-.658-.552.008-.467.008-.892-.463-1.576-.71-1.05-.601-2.118-.601-2.118.646 1.745.838 1.854.876 1.854.004 0 .004-.003.004-.003.733 1.079.865 1.891.842 2.395Z",
    fill: "#23602B"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m98.964 318.938-.075-.094c.053-.027.102-.057.135-.079-.026.116-.06.173-.06.173Zm.094-.331-.53-.207-.102-.124a3.282 3.282 0 0 1-.003-.47c.218.184.436.364.658.553 0 .09-.011.173-.023.248Z",
    fill: "#1C4622"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m98.888 318.844-.36-.444.53.207c-.012.057-.02.113-.034.158a1.183 1.183 0 0 1-.136.079Z",
    fill: "#1C4622"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M100.882 320.07c-.091-.101-.17-.192-.237-.267.883-1.023-.756-4.261-.756-4.261 1.982 2.749 1.324 4.103.993 4.528Z",
    fill: "#2A7D34"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m100.738 320.22-.086-.064c.018-.041.03-.06.03-.06l-.203-.147c.06-.041.12-.09.165-.146.068.075.147.165.237.267a1.49 1.49 0 0 1-.143.15Z",
    fill: "#1C4622"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m100.652 320.156-.233-.169a.285.285 0 0 1 .06-.038l.203.147s-.011.019-.03.06ZM102.171 317.983s-.274 1.836.064 2.419c.339.586-.383 1.561-.383 1.561l.297.218s.632-.764.346-2.016c0 0-.365-.527-.324-2.182ZM108.554 323.388s-2.17 2.606-4.495.53l-.489.354s2.422 2.617 5.115.105l-.131-.989Z",
    fill: "#1C4622"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M111.22 301.442c-.113-.03-.237-.057-.353-.094-2.656 11.362-5.269 29.674 2.527 38.67l.444-.959s-8.034-10.316-2.618-37.617Z",
    fill: "#225E2C"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M113.711 279.327s-1.715 2.065-1.979 4.039c0 0-2.358 4.405.072 8.038 0 0 1 1.538.586 2.388l.993-.673s8.944.447 4.912-12.261c0 0-1.493-2.877.395-4.999 0 0-4.442 2.588-4.979 3.468Z",
    fill: "#35AB41"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M114.045 287.966s1.339-5.085 3.343-10.55c0 0-2.662 4.803-3.983 10.738 0 0-2.234 11.166-2.55 13.152l.027 1.88s2.941-14.525 3.163-15.22Z",
    fill: "#1C4622"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M115.109 284.261c.083-.267.166-.545.256-.835.986-.778 2.543-3.607 2.543-3.607-.918 2.723-2.419 4.122-2.799 4.442Z",
    fill: "#25692E"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m115.02 284.337.308-.884c.015-.007.023-.019.038-.026-.091.289-.173.568-.256.835l-.09.075Z",
    fill: "#1C4622"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M114.35 286.846c.064-.214.131-.451.206-.722.508-.151.937-.196 1.512-.91.76-.933 2.486-1.802 2.486-1.802-1.621 1.226-2.17 1.986-2.17 1.986-.827 1.015-1.568 1.346-2.034 1.448Z",
    fill: "#25692E"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 286.887c-.083 0-.128-.004-.128-.004l.064-.09c.038.033.072.067.102.094h-.038Zm.177-.008.041-.508.117-.165c.075-.03.158-.06.233-.083-.075.271-.143.508-.207.722-.064.015-.128.03-.184.034Z",
    fill: "#1C4622"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M114.399 288.914c-.225 0-.413-.034-.556-.079.034-.143.06-.271.083-.38.131.056.282.083.443.083 1.49 0 3.9-2.291 3.9-2.291-1.696 2.208-3.046 2.667-3.87 2.667Z",
    fill: "#23602B"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M113.842 288.835a1.266 1.266 0 0 1-.297-.12l.083-.241c-.019.004-.042.004-.061.004l.072-.214c.09.086.18.146.286.191-.023.11-.049.237-.083.38ZM118.86 289.136s-2.55.372-3.197 1.057c-.643.692-2.238.112-2.238.112l-.169.486s1.267.534 2.828-.343c0 0 .557-.699 2.776-1.312Z",
    fill: "#1C4622"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M114.738 283.532c-.072-.869-.053-2.437.65-4.355 0 0-.361 2.091-.334 3.471-.106.29-.211.583-.316.884Z",
    fill: "#2A7D34"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M114.843 284.273s-.068-.267-.106-.741c.106-.301.211-.594.316-.884.012.309.034.58.087.783l-.297.842Z",
    fill: "#1C4622"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M113.783 286.627c-.264-.357-.576-1.019-.591-2.166.011 0 .162-.022-.286-1.79 0 0 .613.73.621 1.839.011.737.218 1.046.462 1.38-.075.245-.139.485-.206.737Z",
    fill: "#23602B"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M114.157 286.988s-.049-.034-.131-.102c.041 0 .086-.003.139-.007l-.008.109Zm-.233-.196a4.193 4.193 0 0 1-.143-.165c.068-.252.132-.493.207-.737.072.105.154.214.23.342l-.012.139-.282.421Z",
    fill: "#1C4622"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M114.026 286.886c-.03-.026-.064-.06-.101-.094l.282-.421-.041.508a1.895 1.895 0 0 1-.14.007Z",
    fill: "#1C4622"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M113.289 288.753c-.478-.169-1.565-.873-1.504-3.773 0 0 .425 3.137 1.568 3.472a9.925 9.925 0 0 0-.064.301Z",
    fill: "#2A7D34"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M113.511 288.801s-.087-.004-.222-.049c.023-.117.045-.218.064-.301.06.019.128.026.196.026h.018l-.071.207s.011.015.049.03l-.034.087Z",
    fill: "#1C4622"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M113.545 288.714c-.038-.015-.049-.03-.049-.03l.072-.207c.018 0 .041 0 .06-.003l-.083.24ZM111.349 287.898s1.12 1.193 1.166 1.791c.052.601 1.068.944 1.068.944l-.113.304s-.839-.237-1.26-1.29c0 0 0-.564-.861-1.749Z",
    fill: "#1C4622"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M121.801 367.075H99.532l-2.456-30.648h27.185l-2.46 30.648Z",
    fill: "#BC4641"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "m123.746 342.839.515-6.412H97.076l.512 6.412h26.158Z",
    fill: "#9C3534"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M125.986 338.808c0 .319-.26.586-.583.586H95.931a.59.59 0 0 1-.586-.586v-3.814c0-.323.263-.583.586-.583h29.472c.323 0 .583.26.583.583v3.814Z",
    fill: "#BC4641"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M125.986 336.028v-1.034a.582.582 0 0 0-.583-.583H95.931a.585.585 0 0 0-.586.583v1.034h30.641Z",
    fill: "#DB615D"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m99.38 365.172.151 1.903H121.8l.154-1.903H99.381Z",
    fill: "#9C3534"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 305,
    width: 12,
    height: 13
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M145.687 305.787h10.538v12.148h-10.538v-12.148Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 305,
    width: 11,
    height: 13
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M149.895 306.998c-1.29 1.414-5.051 12.02-3.847 10.538 2.422-2.975 7.668-4.46 8.958-5.874a3.46 3.46 0 0 0-5.111-4.664Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#g)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 305,
    width: 11,
    height: 13
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M149.895 306.998c-1.29 1.414-5.051 12.02-3.847 10.538 2.422-2.975 7.668-4.46 8.958-5.874a3.46 3.46 0 0 0-5.111-4.664Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#h)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 143,
    y: 304,
    width: 15,
    height: 17
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m157.571 305.613-12.622-1.204-1.384 14.484 12.622 1.207 1.384-14.487Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.447 305.903-11.667-1.113-1.312 13.754 11.663 1.113 1.316-13.754Z",
    fill: "url(#j)"
  })))))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M139.365 300.16c1.192 1.139 6.085 7.785 4.438 7.657-2.855-.214-7.372-2.196-8.564-3.332a2.986 2.986 0 0 1-.102-4.224 3 3 0 0 1 4.228-.101ZM137.882 307.881c3.867 1.907 9.166 9.737 7.105 9.21-8.587-2.188-9.527-1.583-11.31-2.745a3.856 3.856 0 0 1-1.135-5.333c1.162-1.787 3.426-2.073 5.34-1.132Z",
    fill: "#42A647"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M137.179 301.871s.538.226 1.293.662c.768.421 1.723 1.083 2.648 1.79.452.369.873.775 1.287 1.136.391.384.707.79 1 1.113.271.35.44.681.583.892.128.214.199.346.199.346.004 0-.41-.429-.993-1.046-.639-.579-1.482-1.346-2.392-2.046-.447-.357-.887-.726-1.32-1.042l-1.169-.906-1.136-.899ZM135.693 310.491s.719.215 1.745.67a24.2 24.2 0 0 1 1.731.827c.624.305 1.256.711 1.895 1.091.632.402 1.234.861 1.802 1.271.545.444 1.008.918 1.425 1.29.211.188.357.414.5.591.139.18.264.338.365.466l.305.41s-.147-.121-.403-.324c-.12-.105-.267-.24-.436-.383-.181-.139-.354-.324-.572-.485-.451-.32-.97-.696-1.53-1.102-.583-.361-1.174-.801-1.806-1.181-2.508-1.572-5.021-3.141-5.021-3.141Z",
    fill: "#1B4320"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M138.229 316.516c3.87 1.907 9.169 9.741 7.104 9.211-8.586-2.189-9.523-1.583-11.305-2.746a3.843 3.843 0 0 1-1.132-5.329c1.162-1.79 3.426-2.076 5.333-1.136Z",
    fill: "#42A647"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M136.047 319.123s.718.218 1.745.673c.508.226 1.106.493 1.723.828.628.304 1.259.711 1.899 1.09.635.403 1.233.862 1.798 1.272.549.443 1.011.917 1.425 1.29.211.191.357.417.504.59.139.181.263.339.369.466l.3.414-.398-.327a21.303 21.303 0 0 1-.444-.384c-.177-.139-.354-.319-.572-.485-.447-.319-.97-.696-1.527-1.098-.586-.365-1.177-.805-1.805-1.185l-5.017-3.144Z",
    fill: "#1B4320"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M139.427 326.456c3.442 1.696 8.154 8.661 6.319 8.191-7.635-1.948-8.47-1.414-10.061-2.441a3.439 3.439 0 0 1-1.008-4.746c1.035-1.591 3.054-1.843 4.75-1.004Z",
    fill: "#42A647"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M137.483 328.776s.64.192 1.55.595c.455.203.985.44 1.534.733.565.275 1.121.636 1.693.974.564.357 1.098.764 1.595 1.132.492.395.902.816 1.275 1.147.184.166.315.365.443.523.128.158.237.301.324.414.173.233.271.368.271.368s-.519-.432-1.257-1.06c-.395-.29-.861-.625-1.357-.978-.527-.327-1.046-.715-1.606-1.057l-4.465-2.791Z",
    fill: "#1B4320"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M153.002 301.471c-7.169 5.055-8.79 8.192-8.82 5.988-.079-5.085.722-7.748 1.745-9.7a3.998 3.998 0 0 1 5.397-1.674c1.952 1.023 3.479 4.115 1.678 5.386Z",
    fill: "#42A647"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m150.832 297.421-3.543 4.686c-.448.576-.839 1.189-1.256 1.738-.373.571-.723 1.102-1.023 1.561-.516.951-.892 1.605-.892 1.605l.136-.488c.052-.155.109-.343.173-.565.075-.214.135-.47.259-.722.252-.492.519-1.094.869-1.703.372-.587.767-1.215 1.211-1.817.463-.579.903-1.177 1.376-1.685.459-.527.914-.989 1.309-1.376a15.88 15.88 0 0 1 1.381-1.234Z",
    fill: "#1B4320"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M156.161 330.831c-8.368 2.622-10.873 5.112-10.226 3.005 1.482-4.859 3.057-7.157 4.633-8.703a4 4 0 0 1 5.646.053c1.545 1.572 2.053 4.987-.053 5.645Z",
    fill: "#42A647"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M155.337 326.31s-2.403 1.685-4.806 3.377c-.602.414-1.166.88-1.731 1.271-.53.429-1.026.828-1.448 1.174-.786.748-1.342 1.26-1.342 1.26s.101-.158.282-.425c.094-.136.203-.294.338-.482.132-.184.267-.41.459-.613.395-.391.831-.88 1.35-1.354.538-.444 1.11-.925 1.712-1.358.616-.413 1.218-.853 1.824-1.188a25.374 25.374 0 0 1 1.67-.91c.993-.5 1.692-.752 1.692-.752ZM152.536 308.088s-1.776 2.339-3.547 4.686c-.448.579-.835 1.192-1.253 1.738-.376.568-.725 1.105-1.026 1.561-.264.477-.478.88-.636 1.162-.158.282-.256.443-.256.443s.053-.18.14-.488c.048-.155.109-.343.173-.557.071-.222.131-.478.255-.73.252-.492.519-1.09.865-1.7.376-.59.775-1.218 1.219-1.813.459-.582.899-1.184 1.376-1.692.452-.527.914-.985 1.309-1.376.79-.783 1.381-1.234 1.381-1.234Z",
    fill: "#1B4320"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M149.895 306.998c-1.29 1.414-5.051 12.02-3.847 10.538 2.422-2.975 7.668-4.46 8.958-5.874a3.46 3.46 0 0 0-5.111-4.664Z",
    fill: "#42A647"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M152.536 308.088s-1.776 2.339-3.547 4.686c-.448.579-.835 1.192-1.253 1.738-.376.568-.725 1.105-1.026 1.561-.264.477-.478.88-.636 1.162-.158.282-.256.443-.256.443s.053-.18.14-.488c.048-.155.109-.343.173-.557.071-.222.131-.478.255-.73.252-.492.519-1.09.865-1.7.376-.59.775-1.218 1.219-1.813.459-.582.899-1.184 1.376-1.692.452-.527.914-.985 1.309-1.376.79-.783 1.381-1.234 1.381-1.234Z",
    fill: "#1B4320"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M151.678 315.651c-1.452 1.23-6.548 11.272-5.164 9.955 2.783-2.64 8.177-3.448 9.636-4.678a3.458 3.458 0 0 0 .406-4.875 3.465 3.465 0 0 0-4.878-.402Z",
    fill: "#42A647"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M154.16 317.065s-2.061 2.095-4.118 4.194c-.515.515-.985 1.072-1.467 1.561l-1.215 1.418c-.635.88-1.094 1.482-1.086 1.482 0 0 .067-.17.195-.467.068-.15.151-.327.248-.538.094-.203.188-.447.343-.68.316-.459.654-1.023 1.079-1.584.444-.53.918-1.106 1.437-1.64.53-.519 1.041-1.056 1.579-1.5a24.221 24.221 0 0 1 1.475-1.2 15.109 15.109 0 0 1 1.53-1.046Z",
    fill: "#1B4320"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M142.373 298.132s7.571 31.983.331 48.137c0 0-.312.692.865.47 0 0 7.688-11.415-1.196-48.607Z",
    fill: "#1B4320"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M142.765 290.208c.68 1.855 1.214 11.742-.061 10.23-1.696-2.023-5.987-5.901-6.675-7.759a3.59 3.59 0 0 1 2.132-4.603 3.592 3.592 0 0 1 4.604 2.132Z",
    fill: "#42A647"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M138.751 290.283s.395.587.906 1.501c.249.466.557.997.843 1.591.286.586.59 1.222.876 1.858.278.643.538 1.297.775 1.914.244.609.399 1.211.553 1.715.169.497.207.952.263 1.252.041.301.068.474.068.474s-.06-.165-.169-.451c-.102-.29-.241-.699-.456-1.177a72.264 72.264 0 0 0-.703-1.636 58.252 58.252 0 0 0-.835-1.869 61.002 61.002 0 0 0-.808-1.885c-.26-.598-.482-1.169-.685-1.651-.391-.97-.628-1.636-.628-1.636Z",
    fill: "#1B4320"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M154.13 367.071h-21.25l-2.347-25.51h25.94l-2.343 25.51Z",
    fill: "#4D3035"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "m155.984 346.905.489-5.344h-25.94l.497 5.344h24.954Z",
    fill: "#332125"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M158.125 343.542c0 .271-.252.493-.557.493h-28.121c-.312 0-.564-.222-.564-.493v-3.166c0-.275.252-.489.564-.489h28.121c.305 0 .557.214.557.489v3.166Z",
    fill: "#4D3035"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M158.125 341.237v-.861c0-.275-.252-.489-.557-.489h-28.121c-.312 0-.564.214-.564.489v.861h29.242Z",
    fill: "#684348"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m132.737 365.487.143 1.584h21.25l.143-1.584h-21.536Z",
    fill: "#332125"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M193.395 326.181s-10.606-5.961-14.254-15.394c0 0 12.283 11.892 14.254 15.394ZM193.432 322.65s-10.045-6.86-12.855-16.575c0 0 11.2 12.919 12.855 16.575ZM193.101 317.916s-10.045-6.86-12.855-16.575c0 0 11.2 12.919 12.855 16.575ZM192.969 313.823s-9.876-7.101-12.448-16.88c0 0 10.884 13.183 12.448 16.88ZM191.936 309.179s-9.305-7.835-11.125-17.783c0 0 9.846 13.976 11.125 17.783Z",
    fill: "#1B4320"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M192.401 307.016s-8.447-8.756-9.229-18.831c0 0 8.353 14.916 9.229 18.831ZM192.35 301.533s-8.037-9.128-8.361-19.234c0 0 7.661 15.277 8.361 19.234ZM192.06 295.015s-7.586-9.512-7.409-19.621c0 0 6.901 15.634 7.409 19.621ZM191.484 284.849s-6.269-10.422-4.769-20.426c0 0 4.792 16.409 4.769 20.426Z",
    fill: "#1B4320"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M191.239 285.059s7.59-9.508 7.421-19.618c0 0-6.913 15.631-7.421 19.618ZM191.056 277.868s4.325-7.492 3.133-14.585c0 0-3.201 11.727-3.133 14.585ZM191.958 293.709s8.914-8.282 10.245-18.305c0 0-9.151 14.435-10.245 18.305Z",
    fill: "#1B4320"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M191.755 289.489s8.906-8.285 10.241-18.304c0 0-9.15 14.434-10.241 18.304ZM192.248 298.572s8.906-8.278 10.241-18.304c0 0-9.154 14.434-10.241 18.304Z",
    fill: "#1B4320"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M192.229 302.371s8.918-8.278 10.245-18.305c0 0-9.15 14.439-10.245 18.305ZM192.737 307.204s8.906-8.278 10.238-18.308c0 0-9.143 14.442-10.238 18.308ZM192.564 312.849s8.91-8.278 10.242-18.305c0 0-9.147 14.438-10.242 18.305ZM193.546 315.576s9.5-7.609 11.561-17.508c0 0-10.188 13.732-11.561 17.508ZM193.737 320.514s9.501-7.604 11.565-17.503c0 0-10.184 13.727-11.565 17.503Z",
    fill: "#1B4320"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M193.851 324.44s9.496-7.608 11.557-17.507c0 0-10.185 13.731-11.557 17.507Z",
    fill: "#1B4320"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M193.688 327.4s9.493-7.601 11.558-17.504c0 0-10.185 13.728-11.558 17.504Z",
    fill: "#1B4320"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m193.015 333.971-.237-10.042c-.169-6.029-.395-14.063-.733-22.096a674.564 674.564 0 0 0-.542-11.795c-.109-1.88-.169-3.704-.308-5.427-.117-1.719-.233-3.347-.342-4.852-.121-1.504-.166-2.888-.331-4.099-.132-1.219-.249-2.279-.346-3.156l-.309-2.741s.139.989.376 2.734c.124.873.271 1.933.437 3.144.195 1.211.274 2.595.44 4.092.143 1.505.3 3.129.47 4.852.176 1.719.286 3.535.444 5.416.3 3.761.601 7.77.853 11.787.549 8.026.986 16.059 1.309 22.081.301 6.029.504 10.042.504 10.042l-1.685.06ZM189.66 330.254s-7.887.09-12.994-4.021c0 0 10.753 2.693 12.994 4.021ZM188.532 328.265s-7.864-.598-12.588-5.137c0 0 10.471 3.622 12.588 5.137ZM186.813 325.716s-7.865-.598-12.588-5.138c0 0 10.47 3.618 12.588 5.138ZM185.41 323.463s-7.841-.782-12.46-5.439c0 0 10.381 3.87 12.46 5.439ZM183.322 321.187s-7.759-1.381-12.009-6.372c0 0 10.054 4.649 12.009 6.372Z",
    fill: "#1B4320"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M182.883 319.822s-7.575-2.17-11.287-7.571c0 0 9.523 5.66 11.287 7.571ZM181.07 316.768s-7.465-2.52-10.922-8.086c0 0 9.249 6.092 10.922 8.086ZM178.799 313.203s-7.338-2.881-10.524-8.605c0 0 8.944 6.533 10.524 8.605ZM175.177 307.686s-6.894-3.818-9.297-9.915c0 0 8.007 7.654 9.297 9.915Z",
    fill: "#1B4320"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M175.113 307.88s1.17-7.789-2.204-13.408c0 0 1.192 11.008 2.204 13.408ZM172.671 303.908s0-5.607-2.971-9.199c0 0 2.009 7.62 2.971 9.199ZM178.317 312.504s2.317-7.53-.192-13.589c0 0-.448 11.065.192 13.589Z",
    fill: "#1B4320"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M176.835 310.201s2.309-7.533-.192-13.585c0 0-.451 11.061.192 13.585ZM180.055 315.136s2.317-7.53-.192-13.581c0 0-.447 11.061.192 13.581Z",
    fill: "#1B4320"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M181.28 317.276s2.313-7.533-.192-13.588c0 0-.451 11.064.192 13.588ZM183.135 319.822s2.309-7.533-.196-13.589c0 0-.451 11.065.196 13.589ZM184.865 323.045s2.313-7.53-.192-13.589c0 0-.444 11.065.192 13.589ZM186.301 324.257s2.859-7.342.805-13.563c0 0-1.26 10.998-.805 13.563ZM188.013 326.964s2.858-7.341.809-13.566c0 0-1.264 11.001-.809 13.566Z",
    fill: "#1B4320"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M189.344 329.13s2.862-7.341.809-13.566c0 0-1.264 11.001-.809 13.566Z",
    fill: "#1B4320"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M190.217 330.845s2.859-7.341.805-13.566c0 0-1.26 11.001-.805 13.566Z",
    fill: "#1B4320"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M191.969 334.749s-5.389-8.918-10.967-17.715a390.313 390.313 0 0 0-4.133-6.442c-1.313-2.058-2.599-3.942-3.697-5.559-.553-.801-1.031-1.565-1.516-2.193-.47-.639-.876-1.196-1.215-1.655a844.84 844.84 0 0 0-1.068-1.444s.402.519 1.102 1.418c.35.448.775.993 1.264 1.625.504.617.996 1.361 1.576 2.151 1.135 1.591 2.474 3.438 3.84 5.465a445.566 445.566 0 0 1 4.306 6.337 1107.816 1107.816 0 0 1 11.437 17.436l-.929.576ZM197.923 326.528s-5.735-7.688-5.344-15.65c0 0 5.047 12.494 5.344 15.65ZM199.081 323.997s-5.043-8.157-3.964-16.056c0 0 3.942 12.886 3.964 16.056ZM200.36 320.476s-5.047-8.158-3.967-16.052c0 0 3.941 12.889 3.967 16.052ZM201.571 317.482s-4.848-8.266-3.576-16.138c0 0 3.629 12.971 3.576 16.138ZM202.313 313.804s-4.205-8.616-2.332-16.371c0 0 2.625 13.22 2.332 16.371Z",
    fill: "#1B4320"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M203.342 312.397s-3.294-9.007-.635-16.522c0 0 1.252 13.412.635 16.522ZM205.054 308.426s-2.874-9.151.12-16.533c0 0 .643 13.46-.12 16.533ZM206.927 303.634s-2.422-9.278.929-16.503c0 0-.019 13.468-.929 16.503ZM209.763 296.124s-1.185-9.516 3.095-16.244c0 0-1.794 13.351-3.095 16.244Z",
    fill: "#1B4320"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M209.522 296.196s8.508-4.431 11.618-11.768c0 0-9.974 9.056-11.618 11.768ZM211.685 290.957s5.513-4.017 6.924-9.516c0 0-6.059 7.436-6.924 9.516ZM207.277 302.66s9.072-3.122 13.235-9.922c0 0-11.215 7.485-13.235 9.922Z",
    fill: "#1B4320"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M208.473 299.554s9.067-3.125 13.235-9.925c0 0-11.212 7.484-13.235 9.925ZM205.927 306.256s9.068-3.122 13.235-9.918c0 0-11.216 7.484-13.235 9.918Z",
    fill: "#1B4320"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M204.7 308.99s9.072-3.122 13.235-9.918c0 0-11.215 7.477-13.235 9.918ZM203.52 312.638s9.071-3.125 13.235-9.929c0 0-11.212 7.488-13.235 9.929ZM201.591 316.647s9.071-3.121 13.235-9.918c0 0-11.208 7.485-13.235 9.918ZM201.429 318.931s9.274-2.453 13.927-8.929c0 0-11.731 6.642-13.927 8.929ZM199.988 322.545s9.279-2.444 13.931-8.917c0 0-11.731 6.638-13.931 8.917Z",
    fill: "#1B4320"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M198.811 325.414s9.274-2.448 13.93-8.925c0 0-11.734 6.642-13.93 8.925Z",
    fill: "#1B4320"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M197.746 327.497s9.279-2.445 13.931-8.925c0 0-11.731 6.642-13.931 8.925Z",
    fill: "#1B4320"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M195.163 332.019s1.215-2.926 3.043-7.315c1.805-4.397 4.212-10.264 6.536-16.161a498.472 498.472 0 0 0 3.374-8.677c.523-1.384 1.064-2.719 1.516-4.006.462-1.278.902-2.489 1.305-3.606.391-1.121.805-2.133 1.075-3.062.29-.921.542-1.719.753-2.381.421-1.323.658-2.076.658-2.076l-.602 2.091c-.192.666-.425 1.479-.696 2.408-.248.932-.632 1.955-.993 3.084-.376 1.128-.778 2.354-1.207 3.648-.421 1.297-.925 2.644-1.414 4.047a512.65 512.65 0 0 1-3.152 8.767c-2.17 5.964-4.423 11.892-6.115 16.337l-2.847 7.402-1.234-.5Z",
    fill: "#1B4320"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M205.817 366.627h-24.029l-2.647-33.066h29.324l-2.648 33.066Z",
    fill: "#BC4641"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m207.912 340.481.553-6.92h-29.324l.552 6.92h28.219Z",
    fill: "#9C3534"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M210.335 336.13c0 .35-.282.632-.636.632h-31.792a.63.63 0 0 1-.632-.632v-4.11c0-.346.282-.632.632-.632h31.792c.354 0 .636.286.636.632v4.11Z",
    fill: "#BC4641"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M210.335 333.137v-1.117a.634.634 0 0 0-.636-.632h-31.792a.633.633 0 0 0-.632.632v1.117h33.06Z",
    fill: "#DB615D"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "m181.627 364.573.162 2.054h24.029l.162-2.054h-24.353Z",
    fill: "#9C3534"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M361.185 285.912s-3.272 16.707-.105 25.105c0 0 2.971-4.412.105-25.105Z",
    fill: "#42A647"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M354.855 288.143s.854 16.999 5.958 24.386c0 0 1.816-4.995-5.958-24.386Z",
    fill: "#42A647"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M350.06 291.269s4.14 16.51 10.576 22.769c0 0 .816-5.251-10.576-22.769Z",
    fill: "#42A647"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M344.629 295.71s8.161 14.942 15.973 19.377c0 0-.538-5.285-15.973-19.377Z",
    fill: "#42A647"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M337.924 301.611s13.291 12.404 22.69 14.285c0 0-2.317-5.176-22.69-14.285Z",
    fill: "#42A647"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M334.918 308.99s16.398 8.662 26.15 7.996c0 0-3.663-4.475-26.15-7.996Z",
    fill: "#42A647"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M329.822 313.695s19.858 7.376 30.81 5.172c0 0-4.821-4.521-30.81-5.172Z",
    fill: "#42A647"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M335.986 321.8s16.902 2.129 25.067-1.602c0 0-4.599-2.663-25.067 1.602Z",
    fill: "#42A647"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M341.342 329.191s13.919-3.02 19.324-8.229c0 0-4.37-.82-19.324 8.229Z",
    fill: "#42A647"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M351.64 330.852s7.996-3.697 9.007-8.661c0 0-3.426-.384-9.007 8.661ZM367.839 289.264s-.997 16.992-6.161 24.337c0 0-1.775-5.013 6.161-24.337Z",
    fill: "#42A647"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M372.604 292.435s-4.277 16.469-10.768 22.675c0 0-.767-5.258 10.768-22.675Z",
    fill: "#42A647"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M378 296.918s-8.293 14.871-16.139 19.241c0 0 .583-5.28 16.139-19.241Z",
    fill: "#42A647"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M384.653 302.875s-13.393 12.295-22.814 14.093c0 0 2.366-5.161 22.814-14.093Z",
    fill: "#42A647"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M387.595 310.279s-16.466 8.519-26.214 7.778c0 0 3.704-4.449 26.214-7.778Z",
    fill: "#42A647"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M392.658 315.03s-19.922 7.203-30.859 4.912c0 0 4.859-4.487 30.859-4.912Z",
    fill: "#42A647"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M386.421 323.083s-16.917 1.982-25.052-1.817c0 0 4.626-2.625 25.052 1.817Z",
    fill: "#42A647"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M381.005 330.424s-13.893-3.137-19.256-8.395c0 0 4.378-.782 19.256 8.395Z",
    fill: "#42A647"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M370.697 331.68s-7.97-3.761-8.932-8.741c0 0 3.426-.357 8.932 8.741Z",
    fill: "#42A647"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M364.939 354.232c.102-.764-.846-5.033-.846-5.033-.85-2.647-1.463-13.216-1.463-13.216.007-22.588-1.245-24.623-1.459-27.463l.003-.41s-.003.072-.019.203a8.03 8.03 0 0 1-.015-.203l-.003.41c-.237 2.84-1.144 13.461-.929 27.448 0 0-.7 10.572-1.572 13.209 0 0-.715 2.339-.504 3.641 0 0 3.911-.252 5.652 1.41 0 0 .482.402 1.155.004Z",
    fill: "#2A512E"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M372.37 366.625h-22.269l-2.455-30.656h27.184l-2.46 30.656Z",
    fill: "#BC4641"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "m374.315 342.385.515-6.416h-27.184l.519 6.416h26.15Z",
    fill: "#9C3534"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M376.564 338.352a.588.588 0 0 1-.587.583h-29.475a.584.584 0 0 1-.587-.583v-3.814c0-.324.263-.587.587-.587h29.475a.59.59 0 0 1 .587.587v3.814Z",
    fill: "#BC4641"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M376.564 335.572v-1.034a.59.59 0 0 0-.587-.587h-29.475a.587.587 0 0 0-.587.587v1.034h30.649Z",
    fill: "#DB615D"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "m349.951 364.721.151 1.903h22.269l.154-1.903h-22.574Z",
    fill: "#9C3534"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M401.206 299.91s-3.682 1.651-4.618 2.697l-.437.933s2.878-2.434 5.232-2.814l-.177-.816Z",
    fill: "#1C4622"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M411.782 292.073s-10.959-.154-11.129 8.271c0 0 4.656 5.961 9.869.515 0 0 2.49-2.422 3.949-5.201 0 0 1.057-2.437 2.75-3.423 0 0-2.753.305-5.439-.162Z",
    fill: "#35AB41"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M408.706 296.187c-.17 0-.264-.011-.264-.011l.971-.538c.06.008.128.008.195.008 1.565 0 4.98-1.208 4.98-1.208-2.802 1.603-5.13 1.749-5.882 1.749ZM407.941 298.027c-.989 0-1.572-.282-1.865-.488l.376-.361.248-.057c.538.203.862.497 1.572.497.162 0 .339-.015.546-.049.21-.034.444-.053.68-.053 1.208 0 2.614.38 2.614.38a19.644 19.644 0 0 0-1.56-.068c-1.099 0-1.61.113-1.61.113a5.849 5.849 0 0 1-1.001.086Zm-1.974-.575c-.083-.071-.124-.117-.124-.117l.113-.03c.003.057.007.106.011.147Z",
    fill: "#25692E"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M407.578 300.035c-2.855 0-3.227-1.576-3.227-1.576l.398-.226c.091 1.475 3.46 1.591 4.54 1.591.21 0 .335-.003.335-.003-.798.15-1.467.214-2.046.214Z",
    fill: "#23602B"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M407.754 302.071s-2.192-1.437-3.144-1.351c-.955.091-1.775-1.421-1.775-1.421l-.459.256s.609 1.263 2.384 1.643c0 0 .899-.154 2.994.873Z",
    fill: "#1C4622"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M408.353 296.019s1.019-1.986 3.851-3.513c0 0-2.516 2.012-3.062 3.069l-.789.444Z",
    fill: "#2A7D34"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M406.001 297.613s-.018-.056-.034-.162c.034.03.072.057.11.087l-.076.075Zm-.045-.308c-.015-.414.109-1.219 1.016-2.261 0 0 .616-.628 1.489-2.32 0 0-.526 1.733-1.271 2.583-.651.745-.515 1.17-.636 1.776l-.101.094-.497.128Z",
    fill: "#23602B"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M406.076 297.538c-.037-.03-.075-.057-.109-.087l-.011-.146.497-.128-.377.361Z",
    fill: "#1E5025"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M404.256 298.293s-1.459-1.459 1.425-4.565c0 0-2.335 3.482-1.075 4.374l-.35.191Z",
    fill: "#2A7D34"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M402.755 295.353s.053 1.794-.342 2.32c-.399.519.184 1.546.184 1.546l-.312.173s-.515-.809-.094-1.982c0 0 .41-.467.564-2.057Z",
    fill: "#1C4622"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M415.821 292.709s-9.432 3.054-15.168 7.635l.474.5s5.476-4.122 14.694-8.135Z",
    fill: "#1C4622"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M412.015 302.085s-15.774 4.566-12.178 14.781c0 0 8.537 3.828 9.865-6.292 0 0 1.335-7.447 2.313-8.489Z",
    fill: "#35AB41"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M402.853 312.311s3.716-4.656 8.286-9.414c0 0-4.957 3.773-9.027 9.316 0 0-1.922 3.171-2.76 4.98l.549.256s2.407-4.517 2.952-5.138Z",
    fill: "#1C4622"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "m405.647 308.959.651-.752c1.373-.361 4.288-2.576 4.288-2.576-2.197 2.403-4.397 3.167-4.939 3.328Z",
    fill: "#25692E"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m405.523 308.99.723-.771a.125.125 0 0 0 .052-.011l-.65.752c-.079.023-.125.03-.125.03Z",
    fill: "#1C4622"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M404.222 311.341c-.21 0-.391-.022-.537-.049.161-.195.346-.413.545-.654.267.03.504.083.775.083.323 0 .699-.076 1.207-.335 1.211-.624 3.396-.73 3.396-.73-2.234.523-3.155 1.065-3.155 1.065-.948.485-1.693.62-2.231.62Z",
    fill: "#25692E"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M403.685 311.292a1.687 1.687 0 0 1-.203-.053l.274-.507.192-.121c.098.008.192.019.282.027-.199.24-.384.458-.545.654Zm-.358-.105c-.109-.045-.169-.083-.169-.083l.113-.068c.015.06.041.109.056.151Z",
    fill: "#1C4622"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M404.098 313.706c-.914 0-1.489-.297-1.801-.549.079-.14.158-.267.233-.377.339.346.922.471 1.591.471 1.692 0 3.896-.794 3.896-.794-1.722.944-3.001 1.249-3.919 1.249Z",
    fill: "#23602B"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M402.297 313.157a1.917 1.917 0 0 1-.305-.297l.2-.215a1.564 1.564 0 0 0-.064-.022l.176-.188a.91.91 0 0 0 .226.346 5.25 5.25 0 0 0-.233.376ZM407.314 315.722s-2.817-.783-3.803-.361c-.981.413-2.365-.907-2.365-.907l-.399.425s1.072 1.128 3.088.933c0 0 .903-.47 3.479-.09Z",
    fill: "#1C4622"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M405.599 308.035c.319-.936 1.06-2.55 2.666-4.223 0 0-1.331 2.008-1.929 3.452a34.2 34.2 0 0 0-.737.771Z",
    fill: "#2A7D34"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M405.373 308.852s.053-.309.226-.816c.244-.264.492-.523.737-.771a3.857 3.857 0 0 0-.271.85l-.692.737Z",
    fill: "#1C4622"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M403.2 310.804c-.117-.489-.136-1.317.376-2.513h.004c.03 0 .199-.09.515-1.985 0 0 .305 1.03-.196 2.189-.331.767-.248 1.184-.154 1.639-.184.222-.365.44-.545.67Z",
    fill: "#23602B"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M403.421 311.344s-.041-.049-.094-.158a.884.884 0 0 0 .154.053l-.06.105Zm-.15-.309a1.054 1.054 0 0 1-.072-.233c.181-.229.361-.447.546-.669.033.146.064.293.082.459l-.071.139-.485.304Z",
    fill: "#1C4622"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M403.481 311.238a.983.983 0 0 1-.154-.052c-.015-.042-.041-.091-.056-.151l.485-.305-.275.508Z",
    fill: "#1C4622"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M401.755 312.819c-.406-.357-1.308-1.561.125-4.633 0 0-1.005 3.49.052 4.325l-.177.308Z",
    fill: "#2A7D34"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M401.92 312.936s-.067-.034-.165-.117l.177-.308c.06.045.124.082.195.113l-.169.18.034.057-.072.075Z",
    fill: "#1C4622"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "m401.992 312.861-.034-.056.169-.181c.023.008.045.015.064.023l-.199.214ZM400.093 311.013s.613 1.749.395 2.388c-.226.636.669 1.459.669 1.459l-.252.271s-.76-.636-.718-1.914c0 0 .256-.591-.094-2.204ZM394.842 317.517s2.617 2.155 4.509-.324l.549.256s-1.888 3.028-5.002 1.061l-.056-.993ZM395.109 324.87s1.647-.824 5.22-3.727l-.041.804s-3.46 3.34-5.314 3.705l.135-.782Z",
    fill: "#1C4622"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M411.41 314.982s-2.949-.191-4.784.768c0 0-5.352.673-6.65 4.863 0 0-.571 1.752-1.576 1.918l1.268.425s5.999 7.717 13.724-3.246c0 0 1.339-2.96 4.453-2.659 0 0-5.322-2.148-6.435-2.069Z",
    fill: "#35AB41"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M404.312 320.134s5.266-1.779 11.314-3.223c0 0-5.939.5-11.908 2.791 0 0-4.709 2.644-6.236 3.625l2.009-.68c3.054-1.723 2.963-1.979 4.821-2.513Z",
    fill: "#1C4622"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M410.609 319.179c-1.234 0-2.092-.188-2.4-.267.286-.087.583-.173.891-.264.527.151 1.384.196 2.231.196 1.312 0 2.602-.109 2.602-.109a12.92 12.92 0 0 1-3.324.444Z",
    fill: "#25692E"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M408.209 318.912c-.083-.022-.124-.038-.124-.038l.967-.24c.018.004.033.007.048.015-.308.09-.605.177-.891.263Z",
    fill: "#1C4622"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M411.308 321.348c-2.159-.673-3.189-.703-3.189-.703-1.437-.121-2.227-.557-2.637-.892.226-.075.478-.15.756-.244.482.346.817.681 1.821.763 1.316.106 3.249 1.076 3.249 1.076Z",
    fill: "#25692E"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M405.482 319.754c-.056-.053-.109-.098-.154-.143l.462-.256h.219c.082.057.161.106.229.155-.278.094-.53.169-.756.244Zm-.26-.252a1.543 1.543 0 0 1-.105-.147h.121a.711.711 0 0 0-.016.147Z",
    fill: "#1C4622"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M408.69 322.729c-3.957-.214-4.998-1.636-5.273-2.306.12-.045.248-.09.391-.135.414 1.542 4.882 2.441 4.882 2.441Z",
    fill: "#23602B"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M403.417 320.424c-.052-.128-.075-.226-.09-.286l.267-.064c-.015-.019-.034-.034-.045-.053l.237-.056a.837.837 0 0 0 .023.323 7.948 7.948 0 0 0-.392.136ZM406.633 324.895s-2.072-1.955-3.106-2.109c-1.031-.151-1.633-1.836-1.633-1.836l-.534.132s.422 1.391 2.242 2.204c0 0 .985.079 3.031 1.609Z",
    fill: "#1C4622"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M408.578 318.175c.688-.56 2.042-1.444 4.171-1.945 0 0-2.035.892-3.197 1.708-.316.075-.643.158-.974.237Z",
    fill: "#2A7D34"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M408.018 318.694s.18-.21.56-.519c.331-.079.658-.161.974-.237-.256.185-.474.362-.609.523l-.925.233ZM405.23 319.667s-.011-.06-.008-.165c.027.03.064.068.106.109l-.098.056Z",
    fill: "#1C4622"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M405.283 319.141c.117-.428.467-1.075 1.441-1.741 0 0 0 .004.015.004.056 0 .308-.105 1.312-1.275 0 0-.199.936-1.139 1.58-.628.432-.741.786-.865 1.184-.252.079-.508.162-.764.248Z",
    fill: "#23602B"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M405.791 319.355h-.553c.008-.064.023-.135.045-.214.256-.087.512-.169.764-.248-.038.124-.075.255-.132.394l-.124.068ZM405.328 319.611a2.388 2.388 0 0 1-.105-.109c0-.041.003-.09.015-.147h.553l-.463.256Z",
    fill: "#1C4622"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M403.154 320.018c-.192-.433-.504-1.813 2.155-3.513 0 0-2.433 2.208-1.865 3.355-.083.045-.181.097-.29.158Z",
    fill: "#2A7D34"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M403.233 320.16s-.037-.045-.079-.143l.29-.158a.78.78 0 0 0 .105.162l-.229.057s.004.022.007.06l-.094.022Z",
    fill: "#1C4622"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M403.328 320.138a.897.897 0 0 0-.008-.06l.23-.057c.011.019.03.034.045.053l-.267.064ZM402.518 317.81s-.252 1.636-.726 2.015c-.477.384-.071 1.445-.071 1.445l-.339.086s-.372-.854.23-1.813c0 0 .485-.331.906-1.733Z",
    fill: "#1C4622"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M389.619 278.045s11.546 11.674 3.426 18.835c0 0-9.328-.809-5.548-10.294 0 0 2.468-7.15 2.122-8.541Z",
    fill: "#35AB41"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M392.627 291.442s-.966-5.875-2.644-12.257c0 0 2.49 5.705 3.34 12.535 0 0 .136 3.705-.019 5.69l-.598-.045s.098-5.115-.079-5.923Z",
    fill: "#1C4622"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M391.822 287.146c-.391-.395-1.937-2.137-2.685-5.307 0 0 1.459 3.355 2.486 4.34.067.331.135.658.199.967Z",
    fill: "#25692E"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M391.916 287.24s-.033-.03-.094-.094l-.199-.966.038.034.255 1.026ZM392.913 290.238c-.034 0-.083-.004-.15-.011.041-.031.082-.061.128-.102l.06.109s-.015.004-.038.004Z",
    fill: "#1C4622"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M392.401 290.144c-.515-.166-1.316-.617-2.136-1.847 0 0-.541-.921-2.238-2.471 0 0 1.858 1.162 2.61 2.294.572.865 1.054.963 1.606 1.189.061.308.11.587.158.835Z",
    fill: "#25692E"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M392.604 290.196a1.687 1.687 0 0 1-.203-.052c-.049-.249-.098-.527-.158-.835.087.033.169.071.263.116l.11.196-.012.575Z",
    fill: "#1C4622"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M392.352 292.479c-.902 0-2.486-.527-4.302-3.43 0 0 2.61 3.009 4.295 3.009.12 0 .233-.019.342-.049.004.131.015.282.019.44-.102.019-.218.03-.354.03Z",
    fill: "#23602B"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M392.706 292.449c-.003-.158-.015-.308-.018-.44.127-.037.251-.101.361-.192l.063.249c-.022-.004-.045-.004-.067-.008l.067.278a1.52 1.52 0 0 1-.406.113ZM387.072 292.246s2.84.688 3.498 1.531c.654.846 2.509.365 2.509.365l.139.564s-1.49.47-3.152-.688c0 0-.557-.843-2.994-1.772Z",
    fill: "#1C4622"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M392.319 286.368a49.187 49.187 0 0 0-.267-1.03c.184-1.554-.004-3.953-.004-3.953.59 2.241.444 4.013.271 4.983Z",
    fill: "#2A7D34"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "m392.119 287.187-.244-.978c.083-.229.139-.53.177-.872.09.335.18.677.267 1.03-.098.531-.2.82-.2.82ZM392.604 290.32v-.124c.061.015.113.023.158.03a.7.7 0 0 1-.158.094Z",
    fill: "#1C4622"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M393.064 289.956a27.63 27.63 0 0 0-.151-.85c.305-.354.579-.677.666-1.509.124-1.252.899-2.004.899-2.004-.707 1.971-.523 1.986-.519 1.986-.132 1.293-.557 2-.895 2.377Z",
    fill: "#23602B"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "m392.891 290.125-.275-.504v-.154c.102-.14.2-.252.297-.362.053.279.106.561.151.85a1.81 1.81 0 0 1-.173.17ZM392.762 290.227c-.045-.008-.097-.015-.158-.03l.012-.576.274.504a1.325 1.325 0 0 1-.128.102Z",
    fill: "#1C4622"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M393.342 292.416c0-.132-.004-.252-.008-.354 1.335-.214 2.159-3.75 2.159-3.75-.248 3.382-1.625 3.995-2.151 4.104Z",
    fill: "#2A7D34"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M393.146 292.441h-.004l-.03-.105.06-.026-.06-.245a.406.406 0 0 0 .098.008c.041 0 .083-.008.124-.011.004.101.008.221.008.353a1.018 1.018 0 0 1-.196.026Z",
    fill: "#1C4622"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "m393.113 292.336-.068-.278c.022.003.045.003.068.007l.06.245s-.019.007-.06.026ZM395.669 291.651s-1.384 1.226-1.504 1.892c-.113.666-1.298.948-1.298.948l.09.361s.971-.181 1.561-1.324c0 0 .064-.639 1.151-1.877ZM397.088 299.889s-3.34.605-3.784-2.479l-.598-.045s.169 3.562 3.848 3.366l.534-.842ZM395.5 307.215s-1.229-1.373-3.471-5.386l-.259.756s1.974 4.382 3.565 5.405l.165-.775Z",
    fill: "#1C4622"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M384.015 292.001s2.809.914 4.152 2.483c0 0 4.731 2.599 4.385 6.976 0 0-.12 1.839.753 2.362l-1.336-.071s-8.421 4.953-11.55-8.086c0 0-.143-3.246-3.151-4.115 0 0 5.739-.026 6.747.451Z",
    fill: "#35AB41"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M388.701 299.414s-4.235-3.599-9.32-7.172c0 0 5.329 2.659 10.03 6.992 0 0 2.287 2.524 3.34 4.005l-.496.294s-2.941-3.645-3.554-4.119Z",
    fill: "#1C4622"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M385.53 296.839c-.55-.068-2.799-.455-5.255-2.279 0 0 3.133 1.568 4.525 1.703l.73.576Z",
    fill: "#25692E"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m385.657 296.854-.128-.015-.729-.575c.015.003.034.003.052.003l.805.587Z",
    fill: "#1C4622"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M386.718 298.774c-.462 0-1.042-.075-1.749-.289 0 0-.962-.358-3.219-.527 0 0 .523-.045 1.204-.045.699 0 1.568.049 2.215.248.372.113.665.155.917.155.403 0 .7-.106 1.054-.192.221.184.428.353.613.504a3.524 3.524 0 0 1-1.035.146Z",
    fill: "#25692E"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M387.753 298.629c-.185-.151-.391-.32-.613-.504.086-.023.173-.042.27-.061l.204.083.334.406c-.06.023-.124.053-.195.076Zm.334-.14c.012-.041.031-.086.042-.139l.113.045s-.049.042-.155.094Z",
    fill: "#1C4622"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M386.955 300.84c-.831 0-1.907-.165-3.283-.632 0 0 1.403.256 2.809.256 1.08 0 2.159-.15 2.599-.681.087.087.177.188.279.297-.35.328-1.061.76-2.404.76Z",
    fill: "#23602B"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M389.359 300.08c-.101-.109-.191-.21-.278-.297a.955.955 0 0 0 .173-.331l.196.139a.204.204 0 0 1-.061.027l.222.161a1.72 1.72 0 0 1-.252.301ZM384.777 302.981s2.656-1.053 3.671-.812c1.016.24 2.2-1.099 2.2-1.099l.444.32s-.906 1.132-2.9 1.215c0 0-.94-.294-3.415.376Z",
    fill: "#1C4622"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M385.458 296.022c-.274-.203-.549-.395-.812-.583-.779-1.189-2.339-2.772-2.339-2.772 1.79 1.256 2.719 2.576 3.151 3.355Z",
    fill: "#2A7D34"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "m385.79 296.707-.775-.557a3.482 3.482 0 0 0-.369-.711c.264.189.538.38.813.583.241.425.331.685.331.685Z",
    fill: "#1C4622"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M388.166 298.133c-.207-.173-.414-.346-.62-.512.033-.41.06-.79-.365-1.418-.636-.947-.474-1.891-.474-1.891.541 1.583.726 1.673.756 1.673.004 0 .011-.004.011-.004.655.982.741 1.712.692 2.152Z",
    fill: "#23602B"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "m388.016 298.639-.068-.086c.049-.023.102-.045.14-.064-.038.101-.072.15-.072.15Zm.113-.289-.515-.203-.091-.113c0-.147.008-.286.023-.414.207.166.414.339.621.512-.012.082-.023.158-.038.218Z",
    fill: "#1C4622"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m387.949 298.554-.335-.407.516.204c-.012.052-.031.097-.042.139-.037.019-.09.041-.139.064Z",
    fill: "#1C4622"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M389.837 299.715c-.079-.098-.155-.177-.215-.248.929-.869-.504-3.799-.504-3.799 1.794 2.505 1.072 3.682.719 4.047Z",
    fill: "#2A7D34"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m389.694 299.844-.083-.064c.023-.03.03-.049.03-.049l-.192-.139a.572.572 0 0 0 .173-.124c.06.071.136.15.215.248-.079.087-.143.128-.143.128Z",
    fill: "#1C4622"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m389.611 299.78-.222-.162a.237.237 0 0 0 .06-.026l.192.139s-.008.019-.03.049ZM391.224 297.913s-.372 1.614-.067 2.144c.297.534-.467 1.369-.467 1.369l.279.203s.662-.647.455-1.768c0 0-.327-.485-.2-1.948ZM390.976 311.713s2.779 2.926 3.249 4.25l.045 1.03s-1.737-3.347-3.768-4.596l.474-.684Z",
    fill: "#1C4622"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M384.176 300.446s10.192 4.02 7.15 11.873c0 0-6.575 3.75-9.324-3.264 0 0-1.388-3.19-1.681-6.311 0 0-.049-2.663-1.249-4.213 0 0 2.441 1.328 5.104 1.915Z",
    fill: "#35AB41"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M385.703 305.519s-2.602-.838-5.024-3.953c0 0 2.937 2.633 4.329 3.077l.695.876ZM386.865 307.719c-.523 0-1.301-.15-2.298-.767 0 0-.827-.579-2.915-1.249 0 0 2.069.271 3.171.952.564.349.951.417 1.312.417.125 0 .245-.011.362-.015.124-.007.248-.019.376-.019h.082l.207.158.211.47c-.128.03-.297.053-.508.053Zm.639-.09a.712.712 0 0 0 .068-.128l.094.064s-.056.034-.162.064Z",
    fill: "#25692E"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M386.929 309.836c-.846 0-2.049-.319-3.7-1.402 0 0 2.207.996 3.753.996.624 0 1.136-.158 1.354-.613l.286.358s-.478.661-1.693.661Z",
    fill: "#23602B"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M384.097 311.228s2.576-.5 3.426-.06c.846.443 2.178-.64 2.178-.64l.331.407s-1.046.936-2.829.616c0 0-.774-.481-3.106-.323Z",
    fill: "#1C4622"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m385.849 305.398-.568-.707c-.101-1.185-1.666-4.002-1.666-4.002 2.042 2.486 2.234 4.709 2.234 4.709Z",
    fill: "#2A7D34"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m387.415 307.768-.042-.102a.8.8 0 0 0 .132-.038c-.049.091-.09.14-.09.14Zm.157-.267-.409-.305-.061-.128c.124-.609.407-.948.087-1.884-.365-1.072-.192-2.877-.192-2.877.166 1.899.5 2.715.5 2.715.437 1.309.245 2.099.075 2.479Z",
    fill: "#23602B"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "m387.373 307.666-.211-.47.41.305c-.023.049-.045.098-.068.128a.867.867 0 0 1-.131.037Z",
    fill: "#1E5025"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "m388.769 309.062-.248-.316c1.504-.35.673-4.449.673-4.449 1.478 3.968-.425 4.765-.425 4.765Z",
    fill: "#2A7D34"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M391.273 306.906s-.726 1.64-.56 2.272c.169.636-.76 1.361-.76 1.361l.222.282s.782-.556.842-1.794c0 0-.203-.59.256-2.121Z",
    fill: "#1C4622"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M380.193 299.502s7.568 6.405 11.133 12.817l-.632.29s-3.494-5.897-10.501-13.107Z",
    fill: "#1C4622"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M374.484 310.875s16.353 1.527 14.74 12.235c0 0-7.661 5.367-10.873-4.329 0 0-2.708-7.064-3.867-7.906Z",
    fill: "#35AB41"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M385.406 319.205s-4.52-3.878-9.91-7.691c0 0 5.578 2.772 10.625 7.458 0 0 2.478 2.745 3.641 4.37l-.489.354s-3.212-3.987-3.867-4.491Z",
    fill: "#1C4622"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M382.029 316.433c-.56-.053-2.862-.391-5.472-2.339 0 0 3.275 1.632 4.693 1.726.271.211.531.418.779.613Z",
    fill: "#25692E"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M382.156 316.444s-.041 0-.127-.012c-.249-.195-.508-.402-.779-.613h.053l.853.625Z",
    fill: "#1C4622"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M383.187 318.57c-.44 0-.974-.068-1.621-.256 0 0-1-.357-3.298-.451 0 0 .816-.117 1.748-.117.591 0 1.227.045 1.731.196.342.097.616.139.853.139.455 0 .771-.143 1.14-.26.244.196.462.373.654.538a3.22 3.22 0 0 1-1.207.211Z",
    fill: "#25692E"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M384.394 318.359a24.66 24.66 0 0 0-.655-.538c.087-.03.177-.056.275-.079l.21.083.365.444c-.052.026-.116.06-.195.09Zm.334-.169c.008-.045.023-.102.03-.158l.121.045s-.049.045-.151.113Z",
    fill: "#1C4622"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M383.485 320.89c-.809 0-1.832-.158-3.126-.576 0 0 1.132.181 2.374.181 1.244 0 2.61-.181 3.084-.891.094.094.191.203.297.323-.346.406-1.106.963-2.629.963Z",
    fill: "#23602B"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M386.113 319.928a7.352 7.352 0 0 0-.298-.324c.076-.116.128-.24.158-.379l.203.15c-.018.008-.033.023-.056.038l.233.169a1.43 1.43 0 0 1-.24.346ZM381.668 323.391s2.618-1.298 3.663-1.072c1.046.222 2.155-1.332 2.155-1.332l.474.339s-.842 1.316-2.854 1.5c0 0-.978-.293-3.438.565Z",
    fill: "#1C4622"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M381.904 315.515c-.293-.211-.579-.422-.865-.617-.861-1.309-2.546-3.028-2.546-3.028 1.892 1.339 2.922 2.791 3.411 3.645Z",
    fill: "#2A7D34"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "m382.28 316.279-.82-.598a4.038 4.038 0 0 0-.421-.783c.286.196.572.407.865.617.271.47.376.764.376.764Z",
    fill: "#1C4622"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M384.781 317.784c-.218-.188-.443-.372-.661-.553.007-.462.015-.887-.459-1.579-.707-1.046-.598-2.114-.598-2.114.647 1.745.831 1.854.868 1.854.012 0 .012-.003.012-.003.726 1.079.861 1.891.838 2.395Z",
    fill: "#23602B"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "m384.669 318.363-.079-.094c.053-.031.098-.057.139-.079-.034.112-.06.173-.06.173Zm.09-.331-.534-.207-.098-.124c-.011-.17-.007-.32-.007-.471.218.181.444.365.662.553a2.493 2.493 0 0 1-.023.249Z",
    fill: "#1C4622"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m384.589 318.269-.364-.444.534.207c-.008.056-.023.113-.03.158l-.14.079Z",
    fill: "#1C4622"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "m386.58 319.491-.233-.263c.883-1.023-.76-4.261-.76-4.261 1.986 2.749 1.328 4.099.993 4.524Z",
    fill: "#2A7D34"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "m386.44 319.645-.086-.064c.022-.038.026-.06.026-.06l-.203-.147a.79.79 0 0 0 .169-.146l.233.263c-.075.101-.139.154-.139.154Z",
    fill: "#1C4622"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "m386.353 319.581-.233-.169c.023-.015.038-.03.057-.038l.203.147s-.004.022-.027.06ZM387.869 317.408s-.274 1.836.064 2.419c.346.586-.383 1.56-.383 1.56l.297.218s.632-.763.35-2.012c0 0-.361-.53-.328-2.185ZM394.256 322.812s-2.17 2.607-4.495.531l-.489.353s2.423 2.618 5.119.106l-.135-.99Z",
    fill: "#1C4622"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M396.926 300.866c-.12-.03-.244-.056-.357-.094-2.659 11.366-5.266 29.675 2.527 38.671l.444-.959s-8.037-10.32-2.614-37.618Z",
    fill: "#225E2C"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M399.412 278.748s-1.715 2.069-1.975 4.043c0 0-2.362 4.404.068 8.037 0 0 1 1.535.587 2.385l.993-.67s8.947.448 4.911-12.26c0 0-1.496-2.878.395-4.999 0 0-4.438 2.588-4.979 3.464Z",
    fill: "#35AB41"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M399.747 287.391s1.339-5.085 3.34-10.553c0 0-2.659 4.806-3.976 10.741 0 0-2.238 11.167-2.557 13.153l.034 1.876s2.941-14.521 3.159-15.217Z",
    fill: "#1C4622"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M400.811 283.686c.079-.267.165-.549.252-.835.985-.779 2.55-3.607 2.55-3.607-.922 2.723-2.426 4.122-2.802 4.442Z",
    fill: "#25692E"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m400.721 283.762.312-.884c.007-.008.022-.019.03-.026-.087.285-.173.567-.252.835-.056.045-.09.075-.09.075Z",
    fill: "#1C4622"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M400.055 286.271c.056-.215.128-.452.203-.719.508-.154.94-.203 1.512-.914.759-.932 2.486-1.801 2.486-1.801-1.617 1.222-2.167 1.989-2.167 1.989-.827 1.012-1.575 1.343-2.034 1.445Z",
    fill: "#25692E"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M399.687 286.311c-.076 0-.125-.003-.125-.003l.061-.094c.037.037.075.075.105.097h-.041Zm.18-.007.042-.508.112-.165c.083-.034.162-.06.237-.079-.075.267-.146.504-.203.718a2.758 2.758 0 0 1-.188.034Z",
    fill: "#1C4622"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M400.1 288.335a1.8 1.8 0 0 1-.553-.076c.026-.142.053-.27.079-.379.135.056.282.082.44.082 1.497 0 3.904-2.29 3.904-2.29-1.693 2.208-3.043 2.663-3.87 2.663Z",
    fill: "#23602B"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M399.547 288.26a1.517 1.517 0 0 1-.305-.12l.087-.241c-.023.004-.042.004-.064.004l.079-.215a.883.883 0 0 0 .282.192 6.332 6.332 0 0 0-.079.38ZM404.565 288.561s-2.558.372-3.205 1.056c-.643.685-2.234.113-2.234.113l-.169.485s1.271.534 2.825-.346c0 0 .564-.695 2.783-1.308Z",
    fill: "#1C4622"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M400.439 282.957c-.072-.869-.053-2.437.654-4.359 0 0-.361 2.095-.334 3.475-.106.286-.215.583-.32.884Z",
    fill: "#2A7D34"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M400.548 283.701s-.068-.271-.11-.745c.106-.301.215-.598.32-.884.008.309.03.576.087.783l-.297.846Z",
    fill: "#1C4622"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M399.487 286.052c-.27-.357-.583-1.019-.59-2.166.007 0 .158-.026-.293-1.79 0 0 .616.729.628 1.839.003.737.218 1.045.455 1.38-.068.241-.136.485-.2.737Z",
    fill: "#23602B"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M399.86 286.413s-.053-.03-.132-.102c.041 0 .087-.004.139-.007l-.007.109Zm-.237-.2a2.133 2.133 0 0 1-.136-.161c.064-.252.132-.497.2-.738.079.106.158.215.233.343l-.011.139-.286.417Z",
    fill: "#1C4622"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M399.728 286.311c-.03-.022-.067-.06-.105-.098l.286-.417-.041.508c-.053.003-.098.007-.14.007Z",
    fill: "#1C4622"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M398.99 288.178c-.477-.17-1.568-.873-1.504-3.773 0 0 .425 3.137 1.565 3.472-.019.082-.038.18-.061.301Z",
    fill: "#2A7D34"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M399.213 288.226s-.086-.004-.222-.049c.023-.12.042-.218.06-.301a.677.677 0 0 0 .196.026h.019l-.072.207.049.03-.03.087Z",
    fill: "#1C4622"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "m399.242 288.139-.049-.03.072-.207c.022 0 .041 0 .064-.004l-.087.241ZM397.054 287.323s1.12 1.192 1.166 1.79c.045.598 1.06.944 1.06.944l-.105.305s-.843-.237-1.268-1.29c0 0 0-.572-.853-1.749Z",
    fill: "#1C4622"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M407.505 366.5h-22.269l-2.456-30.648h27.181l-2.456 30.648Z",
    fill: "#BC4641"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "m409.446 342.264.515-6.412H382.78l.512 6.412h26.154Z",
    fill: "#9C3534"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M411.692 338.233c0 .319-.26.586-.587.586H381.63a.586.586 0 0 1-.583-.586v-3.814a.58.58 0 0 1 .583-.583h29.475c.327 0 .587.259.587.583v3.814Z",
    fill: "#BC4641"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M411.692 335.453v-1.034a.582.582 0 0 0-.587-.583H381.63a.58.58 0 0 0-.583.583v1.034h30.645Z",
    fill: "#DB615D"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "m385.079 364.601.158 1.899h22.269l.15-1.899h-22.577Z",
    fill: "#9C3534"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 424,
    y: 320,
    width: 9,
    height: 11
  }, _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M424.415 320.822h8.195v9.542h-8.195v-9.542Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#k)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 424,
    y: 320,
    width: 9,
    height: 10
  }, _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M427.927 321.66c-.963 1.05-3.772 8.97-2.873 7.861 1.805-2.215 5.724-3.329 6.683-4.382a2.58 2.58 0 0 0-3.81-3.479Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#l)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 424,
    y: 320,
    width: 9,
    height: 10
  }, _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M427.927 321.659c-.963 1.05-3.772 8.97-2.873 7.861 1.805-2.215 5.724-3.329 6.683-4.382a2.58 2.58 0 0 0-3.81-3.479Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#m)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "n",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 423,
    y: 319,
    width: 11,
    height: 13
  }, _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m433.657 320.625-9.422-.902-1.034 10.813 9.425.902 1.031-10.813Z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m433.544 320.621-9.056-.865-1.005 10.516 9.057.865 1.004-10.516Z",
    fill: "url(#o)"
  })))))), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M420.064 316.554c.891.85 4.543 5.811 3.317 5.721-2.133-.166-5.506-1.644-6.398-2.494a2.224 2.224 0 0 1-.071-3.148 2.233 2.233 0 0 1 3.152-.079ZM418.961 322.319c2.885 1.422 6.842 7.267 5.3 6.875-6.409-1.636-7.109-1.184-8.44-2.053a2.878 2.878 0 0 1-.846-3.983c.868-1.328 2.557-1.546 3.986-.839Z",
    fill: "#42A647"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M418.435 317.828s.402.169.97.493c.572.316 1.282.808 1.974 1.339.339.271.651.579.956.846.293.29.53.594.752.835.199.259.323.504.429.662l.15.256s-.305-.316-.741-.779c-.474-.429-1.102-1.004-1.783-1.527-.334-.263-.658-.541-.989-.775l-.868-.677c-.512-.402-.85-.673-.85-.673ZM417.326 324.26s.538.165 1.305.504c.775.319 1.753.85 2.704 1.436.471.301.914.647 1.339.952.414.323.756.681 1.072.955.294.305.489.606.643.79l.226.305s-.433-.361-1.053-.892c-.666-.485-1.546-1.132-2.486-1.703-.463-.294-.922-.606-1.369-.862-.44-.267-.85-.522-1.204-.741-.703-.447-1.177-.744-1.177-.744Z",
    fill: "#1B4320"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M419.221 328.766c2.889 1.421 6.838 7.266 5.303 6.875-6.409-1.636-7.108-1.189-8.439-2.054a2.875 2.875 0 0 1-.847-3.983c.862-1.327 2.558-1.545 3.983-.838Z",
    fill: "#42A647"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M417.589 330.706s.534.166 1.301.504c.771.32 1.753.85 2.704 1.429.474.309.911.655 1.343.956.41.327.752.684 1.068.962.294.301.485.602.647.786.143.192.222.305.222.305s-.433-.361-1.049-.891c-.67-.489-1.546-1.132-2.49-1.704-.463-.293-.922-.606-1.369-.861-.436-.267-.85-.527-1.204-.741-.703-.448-1.173-.745-1.173-.745Z",
    fill: "#1B4320"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M420.113 336.178c2.569 1.268 6.085 6.469 4.716 6.119-5.698-1.459-6.322-1.056-7.507-1.824a2.557 2.557 0 0 1-.748-3.543c.767-1.184 2.271-1.372 3.539-.752Z",
    fill: "#42A647"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M418.665 337.912s.474.143 1.155.444c.688.286 1.56.76 2.407 1.275.417.271.808.579 1.188.846.373.293.677.609.952.854.267.271.436.541.579.699.128.173.199.275.199.275s-.387-.32-.936-.79c-.594-.436-1.377-1.012-2.215-1.519-.41-.26-.813-.538-1.215-.764-.391-.24-.756-.466-1.072-.662-.628-.395-1.042-.658-1.042-.658Z",
    fill: "#1B4320"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M430.244 317.532c-5.351 3.776-6.559 6.115-6.585 4.472-.056-3.795.545-5.785 1.309-7.236a2.972 2.972 0 0 1 4.024-1.253c1.456.764 2.595 3.069 1.252 4.017Z",
    fill: "#42A647"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M428.628 314.504s-.335.444-.828 1.106c-.252.327-.541.707-.857 1.117-.324.395-.636.842-.959 1.278-.674.865-1.26 1.776-1.704 2.46a50.413 50.413 0 0 1-.666 1.204s.042-.132.106-.365c.075-.23.154-.572.319-.959.188-.369.384-.82.651-1.268.286-.436.575-.91.899-1.357.681-.881 1.399-1.719 2.004-2.291.591-.587 1.035-.925 1.035-.925Z",
    fill: "#1B4320"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M432.603 339.442c-6.243 1.956-8.116 3.818-7.635 2.246 1.106-3.63 2.287-5.341 3.457-6.492a2.986 2.986 0 0 1 4.22.038c1.15 1.173 1.53 3.719-.042 4.208Z",
    fill: "#42A647"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M431.99 336.07s-.448.32-1.125.798c-.338.237-.733.507-1.154.797-.433.278-.869.613-1.313.929-.902.617-1.737 1.301-2.369 1.824-.587.557-1.001.937-1.001.937l.211-.316c.139-.192.323-.497.594-.813.297-.293.617-.662 1.008-1.011.41-.324.831-.689 1.279-1.012.914-.628 1.858-1.207 2.606-1.569a11.87 11.87 0 0 1 1.264-.564ZM429.895 322.47s-.331.444-.827 1.102c-.248.327-.542.707-.854 1.113-.327.395-.639.846-.963 1.282-.669.862-1.256 1.779-1.703 2.464-.384.715-.662 1.196-.662 1.196s.037-.128.101-.361c.083-.226.154-.576.32-.959.192-.369.384-.82.647-1.271.289-.429.583-.911.906-1.358.677-.873 1.403-1.715 2.005-2.287.59-.583 1.03-.921 1.03-.921Z",
    fill: "#1B4320"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M427.928 321.661c-.963 1.05-3.772 8.97-2.873 7.861 1.805-2.216 5.724-3.329 6.683-4.382a2.58 2.58 0 0 0-3.81-3.479Z",
    fill: "#42A647"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M429.895 322.47s-.331.444-.827 1.102c-.248.327-.542.707-.854 1.113-.327.395-.639.846-.963 1.282-.669.862-1.256 1.779-1.703 2.464-.384.715-.662 1.196-.662 1.196s.037-.128.101-.361c.083-.226.154-.576.32-.959.192-.369.384-.82.647-1.271.289-.429.583-.911.906-1.358.677-.873 1.403-1.715 2.005-2.287.59-.583 1.03-.921 1.03-.921Z",
    fill: "#1B4320"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M429.26 328.115c-1.091.917-4.893 8.413-3.852 7.428 2.073-1.971 6.097-2.569 7.184-3.487a2.582 2.582 0 0 0-3.332-3.941Z",
    fill: "#42A647"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M431.107 329.172s-.384.391-.959.985c-.29.29-.628.632-.99.993-.376.354-.74.76-1.12 1.151-.775.771-1.475 1.598-2.005 2.223-.47.658-.812 1.106-.812 1.106s.052-.128.15-.35c.105-.211.23-.549.44-.91.237-.339.482-.764.805-1.178.342-.387.688-.827 1.072-1.226.782-.782 1.606-1.523 2.279-2.012.658-.504 1.14-.782 1.14-.782Z",
    fill: "#1B4320"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M422.312 315.041s5.65 23.871.245 35.929c0 0-.229.511.647.35 0 0 5.739-8.523-.892-36.279Z",
    fill: "#1B4320"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M422.602 309.126c.512 1.384.907 8.767-.045 7.635-1.264-1.512-4.472-4.404-4.979-5.788a2.673 2.673 0 0 1 1.587-3.434 2.674 2.674 0 0 1 3.437 1.587Z",
    fill: "#42A647"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M419.608 309.178s.294.44.677 1.124c.392.681.858 1.621 1.283 2.577.417.959.79 1.94.989 2.704.128.372.154.711.199.932.03.23.045.358.045.358s-.045-.124-.12-.339c-.079-.214-.18-.523-.338-.876-.309-.718-.715-1.67-1.151-2.618-.399-.959-.828-1.91-1.117-2.636a36.516 36.516 0 0 1-.467-1.226Z",
    fill: "#1B4320"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M431.087 366.495h-15.86l-1.752-19.038h19.361l-1.749 19.038Z",
    fill: "#4D3035"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "m432.471 351.44.365-3.983h-19.361l.372 3.983h18.624Z",
    fill: "#332125"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M434.07 348.936c0 .199-.188.364-.421.364h-20.986c-.23 0-.418-.165-.418-.364v-2.366c0-.207.188-.365.418-.365h20.986c.233 0 .421.158.421.365v2.366Z",
    fill: "#4D3035"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M434.07 347.209v-.639c0-.207-.188-.365-.421-.365h-20.986c-.23 0-.418.158-.418.365v.639h21.825Z",
    fill: "#684348"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "m415.118 365.315.109 1.181h15.86l.106-1.181h-16.075Z",
    fill: "#332125"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M26.048 212.06c8.857 0 16.041-8.045 16.041-17.97H10c0 9.925 7.183 17.97 16.048 17.97Z",
    fill: "#314D37"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M58.126 212.06c8.868 0 16.052-8.045 16.052-17.97h-32.09c0 9.925 7.18 17.97 16.038 17.97Z",
    fill: "#E0C68B"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M90.219 212.06c8.857 0 16.044-8.045 16.044-17.97H74.178c0 9.925 7.176 17.97 16.04 17.97Z",
    fill: "#314D37"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M122.304 212.06c8.861 0 16.045-8.045 16.045-17.97h-32.085c0 9.925 7.179 17.97 16.04 17.97Z",
    fill: "#E0C68B"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M154.392 212.06c8.861 0 16.045-8.045 16.045-17.97h-32.089c0 9.925 7.183 17.97 16.044 17.97Z",
    fill: "#314D37"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M186.477 212.06c8.857 0 16.041-8.045 16.041-17.97h-32.081c0 9.925 7.179 17.97 16.04 17.97Z",
    fill: "#E0C68B"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M218.563 212.06c8.861 0 16.045-8.045 16.045-17.97h-32.089c0 9.925 7.179 17.97 16.044 17.97Z",
    fill: "#314D37"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M250.652 212.06c8.853 0 16.041-8.045 16.041-17.97h-32.086c0 9.925 7.176 17.97 16.045 17.97Z",
    fill: "#E0C68B"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M282.733 212.06c8.865 0 16.045-8.045 16.045-17.97h-32.086c0 9.925 7.176 17.97 16.041 17.97Z",
    fill: "#314D37"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M314.823 212.06c8.861 0 16.037-8.045 16.037-17.97h-32.082c0 9.925 7.188 17.97 16.045 17.97Z",
    fill: "#E0C68B"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M346.908 212.06c8.861 0 16.044-8.045 16.044-17.97h-32.093c0 9.925 7.188 17.97 16.049 17.97Z",
    fill: "#314D37"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M379 212.06c8.858 0 16.034-8.045 16.034-17.97h-32.082c0 9.925 7.184 17.97 16.048 17.97Z",
    fill: "#E0C68B"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M411.081 212.06c8.858 0 16.045-8.045 16.045-17.97h-32.093c0 9.925 7.187 17.97 16.048 17.97Z",
    fill: "#314D37"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M57.298 137.486 10 194.09h32.089l40.025-56.604H57.298Z",
    fill: "#548D5F"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M82.114 137.486 42.089 194.09h32.089l32.739-56.604H82.114Z",
    fill: "#FAEAC2"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "m106.917 137.486-32.74 56.604h32.086l25.462-56.604h-24.808Z",
    fill: "#548D5F"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "m131.726 137.486-25.462 56.604h32.085l18.188-56.604h-24.811Z",
    fill: "#FAEAC2"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "m156.536 137.486-18.188 56.604h32.089l10.914-56.604h-24.815Z",
    fill: "#548D5F"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "m181.351 137.486-10.914 56.604h32.081l3.641-56.604h-24.808Z",
    fill: "#FAEAC2"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "m206.159 137.486-3.64 56.604h32.089l-3.645-56.604h-24.804Z",
    fill: "#548D5F"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "m230.963 137.486 3.644 56.604h32.086l-10.915-56.604h-24.815Z",
    fill: "#FAEAC2"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "m255.778 137.486 10.915 56.604h32.085l-18.188-56.604h-24.812Z",
    fill: "#548D5F"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "m280.59 137.486 18.188 56.604h32.082l-25.463-56.604H280.59Z",
    fill: "#FAEAC2"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "m305.397 137.486 25.463 56.604h32.092l-32.747-56.604h-24.808Z",
    fill: "#548D5F"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "m330.205 137.486 32.747 56.604h32.082l-40.018-56.604h-24.811Z",
    fill: "#FAEAC2"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "m355.017 137.486 40.017 56.604h32.092l-47.302-56.604h-24.807Z",
    fill: "#548D5F"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M389 95.486v-2.585c0-.23-.527-.415-1.175-.415H49.171c-.648 0-1.171.186-1.171.415v2.585h341Z",
    fill: "#E2DCC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 151.635,
    y1: 305.349,
    x2: 150.322,
    y2: 319.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87BE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#86BD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#85BC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#83BB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#82BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#80B939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#7FB939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#7EB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#7CB739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#7BB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#7AB539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#79B539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#77B439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#76B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#74B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#73B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#73B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#71B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#70B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#6FAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#6EAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#6CAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#6BAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6AAC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#69AC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#68AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#67AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#66AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#64A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#63A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#62A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#61A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#60A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#5FA639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#5FA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#5EA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#5DA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#5CA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#5BA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5AA339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#59A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#58A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#57A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#56A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#55A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#54A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#539F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#529F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#509D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#4E9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.215,
    stopColor: "#4C9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#4B9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#499939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#489939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#469739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#439639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#429639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#429539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#3F9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.301,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#3A9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#379039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#358E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358E39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 429.25,
    y1: 320.212,
    x2: 428.246,
    y2: 330.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FC239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#8DC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008,
    stopColor: "#8CC139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#8AC039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#89BF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#87BE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    stopColor: "#86BD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#84BC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#83BB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#82BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.039,
    stopColor: "#80BA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#7FB939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#7DB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.051,
    stopColor: "#7CB739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#7BB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#7AB639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#78B539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.066,
    stopColor: "#77B439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#76B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#74B339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078,
    stopColor: "#73B239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#72B139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.086,
    stopColor: "#71B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#70B039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#6EAF39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#6DAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#6CAE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105,
    stopColor: "#6BAD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#6AAC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#69AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#68AB39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#66AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#65AA39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#64A939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#63A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#62A839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#61A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#60A739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148,
    stopColor: "#5FA639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#5EA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#5DA539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5CA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#5BA439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#5AA339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.172,
    stopColor: "#59A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#58A239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#57A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#56A139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#55A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#54A039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#539F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#529F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#519E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "#509E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#4F9D39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#4D9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.227,
    stopColor: "#4C9C39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4B9B39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#4A9A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242,
    stopColor: "#499939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#489939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#479939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.254,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#479839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.262,
    stopColor: "#469739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#459739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273,
    stopColor: "#449739"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#439639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#429639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#429539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#419539"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.297,
    stopColor: "#409439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305,
    stopColor: "#3F9439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.309,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#3E9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3D9339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#3C9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#3B9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3A9239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#3A9139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#399139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#389039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.383,
    stopColor: "#379039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398,
    stopColor: "#368F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#358F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#358E39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#358E39"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0.543,
    width: 442,
    height: 387.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1314_1172"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1314_1172",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.f69bc2234985f2c2ee8c408acda16959.svg";
export { ForwardRef as ReactComponent };